/* tslint:disable */
/* eslint-disable */
/**
 * api
 * API docs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * @type ActionApproverArrayOrSingleString
 * @export
 */
export type ActionApproverArrayOrSingleString = Array<string> | string;

/**
 * @type ActionCountArrayOrSingleString
 * @export
 */
export type ActionCountArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface ActionDto
 */
export interface ActionDto {
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'status': ActionDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ActionDto
     */
    'dueDate': Date | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ActionDto
     */
    'owner': MinimalUserDto;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ActionDto
     */
    'approver'?: MinimalUserDto;
    /**
     * 
     * @type {Date}
     * @memberof ActionDto
     */
    'deletedAt'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'issueId': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'issueCode': string;
    /**
     * 
     * @type {Array<GovMapGroupDto>}
     * @memberof ActionDto
     */
    'govmapGroups'?: Array<GovMapGroupDto>;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'approvalStatus': ActionDtoApprovalStatusEnum;
    /**
     * 
     * @type {Array<AttachmentResponseDto>}
     * @memberof ActionDto
     */
    'attachments'?: Array<AttachmentResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof ActionDto
     */
    'sequence'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ActionDto
     */
    'updatedAt': string;
}

export const ActionDtoStatusEnum = {
    Draft: 'action-draft',
    Pending: 'action-pending',
    Open: 'action-open',
    InProgress: 'action-in-progress',
    ToBeApproved: 'action-to-be-approved',
    Completed: 'action-completed',
    Discarded: 'action-discarded'
} as const;

export type ActionDtoStatusEnum = typeof ActionDtoStatusEnum[keyof typeof ActionDtoStatusEnum];
export const ActionDtoApprovalStatusEnum = {
    NotSet: 'not-set',
    WaitingForApproval: 'waiting-for-approval',
    Approved: 'approved',
    Denied: 'denied'
} as const;

export type ActionDtoApprovalStatusEnum = typeof ActionDtoApprovalStatusEnum[keyof typeof ActionDtoApprovalStatusEnum];

/**
 * 
 * @export
 * @interface ActionGovmapGroupDto
 */
export interface ActionGovmapGroupDto {
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'actionId': string;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'govmapGroupId': string;
    /**
     * 
     * @type {Date}
     * @memberof ActionGovmapGroupDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof ActionGovmapGroupDto
     */
    'updatedAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof ActionGovmapGroupDto
     */
    'deletedAt': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'parentGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionGovmapGroupDto
     */
    'parentGroupName': string | null;
}
/**
 * @type ActionOwnerArrayOrSingleString
 * @export
 */
export type ActionOwnerArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface ActionTemplateDto
 */
export interface ActionTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionTemplateDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActionTemplateDto
     */
    'sequence'?: number | null;
    /**
     * 
     * @type {Array<GovMapGroupWithoutChildrenDto>}
     * @memberof ActionTemplateDto
     */
    'govmapGroups': Array<GovMapGroupWithoutChildrenDto>;
}
/**
 * 
 * @export
 * @interface ActionTemplateResponseDto
 */
export interface ActionTemplateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateResponseDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateResponseDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionTemplateResponseDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActionTemplateResponseDto
     */
    'govmapGroups'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ActionWithOwnerAndApproverDto
 */
export interface ActionWithOwnerAndApproverDto {
    /**
     * 
     * @type {string}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'owner': MinimalUserDto | null;
    /**
     * 
     * @type {string}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'approver'?: MinimalUserDto | null;
    /**
     * 
     * @type {Array<GovMapGroupWithoutChildrenDto>}
     * @memberof ActionWithOwnerAndApproverDto
     */
    'govmapGroups'?: Array<GovMapGroupWithoutChildrenDto>;
}
/**
 * 
 * @export
 * @interface AddCommentRequestDto
 */
export interface AddCommentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddCommentRequestDto
     */
    'message': string;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof AddCommentRequestDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}
/**
 * @type AddedByArrayOrSingleString
 * @export
 */
export type AddedByArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface ApproveActionDto
 */
export interface ApproveActionDto {
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof ApproveActionDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}
/**
 * 
 * @export
 * @interface ApproveIssueRequestDto
 */
export interface ApproveIssueRequestDto {
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof ApproveIssueRequestDto
     */
    'attachments': Array<SaveAttachmentDto>;
}
/**
 * @type ApproverArrayOrSingleString
 * @export
 */
export type ApproverArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface AssignIssueRequestDto
 */
export interface AssignIssueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AssignIssueRequestDto
     */
    'severity': AssignIssueRequestDtoSeverityEnum;
    /**
     * 
     * @type {Date}
     * @memberof AssignIssueRequestDto
     */
    'dueDate': Date;
    /**
     * 
     * @type {string}
     * @memberof AssignIssueRequestDto
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignIssueRequestDto
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof AssignIssueRequestDto
     */
    'approverId': string;
    /**
     * 
     * @type {Array<SaveActionRequestDto>}
     * @memberof AssignIssueRequestDto
     */
    'actions'?: Array<SaveActionRequestDto>;
    /**
     * 
     * @type {string}
     * @memberof AssignIssueRequestDto
     */
    'selectedTemplateId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignIssueRequestDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof AssignIssueRequestDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}

export const AssignIssueRequestDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type AssignIssueRequestDtoSeverityEnum = typeof AssignIssueRequestDtoSeverityEnum[keyof typeof AssignIssueRequestDtoSeverityEnum];

/**
 * 
 * @export
 * @interface AttachmentDto
 */
export interface AttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentDto
     */
    'expirationDate': string;
}
/**
 * 
 * @export
 * @interface AttachmentResponseDto
 */
export interface AttachmentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AttachmentResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AttachmentResponseDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AttachmentResponseDto
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentResponseDto
     */
    'hbDriveId': string;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentResponseDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof AttachmentResponseDto
     */
    'addedBy': AuthUserDto;
    /**
     * 
     * @type {string}
     * @memberof AttachmentResponseDto
     */
    'attachmentType': AttachmentResponseDtoAttachmentTypeEnum;
}

export const AttachmentResponseDtoAttachmentTypeEnum = {
    Attachment: 'attachment',
    Approval: 'approval',
    Declination: 'declination'
} as const;

export type AttachmentResponseDtoAttachmentTypeEnum = typeof AttachmentResponseDtoAttachmentTypeEnum[keyof typeof AttachmentResponseDtoAttachmentTypeEnum];

/**
 * 
 * @export
 * @interface AuthUserDto
 */
export interface AuthUserDto {
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'initials': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'highbondId': string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ClientMonitoringEventDto
 */
export interface ClientMonitoringEventDto {
    /**
     * 
     * @type {number}
     * @memberof ClientMonitoringEventDto
     */
    'responseTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientMonitoringEventDto
     */
    'target': string;
    /**
     * 
     * @type {string}
     * @memberof ClientMonitoringEventDto
     */
    'type': string;
}
/**
 * @type CodeArrayOrSingleString
 * @export
 */
export type CodeArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface ColumnFiltersDto
 */
export interface ColumnFiltersDto {
    /**
     * 
     * @type {Array<IssueTypesManagedByMeDto>}
     * @memberof ColumnFiltersDto
     */
    'issueTypesManagedByMe': Array<IssueTypesManagedByMeDto>;
    /**
     * 
     * @type {Array<IssueSubtypesManagedByMeDto>}
     * @memberof ColumnFiltersDto
     */
    'issueSubtypesManagedByMe': Array<IssueSubtypesManagedByMeDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ColumnFiltersDto
     */
    'overdueSLAs': Array<number>;
}
/**
 * 
 * @export
 * @interface CreateActionDto
 */
export interface CreateActionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateActionDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActionDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActionDto
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActionDto
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActionDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateActionDto
     */
    'sequence'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateActionTemplateDto
 */
export interface CreateActionTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateActionTemplateDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateActionTemplateDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActionTemplateDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof CreateActionTemplateDto
     */
    'owner'?: AuthUserDto | null;
    /**
     * 
     * @type {number}
     * @memberof CreateActionTemplateDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateActionTemplateDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof CreateActionTemplateDto
     */
    'approver'?: AuthUserDto | null;
    /**
     * 
     * @type {number}
     * @memberof CreateActionTemplateDto
     */
    'sequence'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateIssueRequestDto
 */
export interface CreateIssueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'issueSubtypeId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateIssueRequestDto
     */
    'answerIds'?: Array<string>;
    /**
     * 
     * @type {IssueSourceDto}
     * @memberof CreateIssueRequestDto
     */
    'source'?: IssueSourceDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateIssueRequestDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof CreateIssueRequestDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'severity'?: CreateIssueRequestDtoSeverityEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateIssueRequestDto
     */
    'dueDate'?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueRequestDto
     */
    'ownerId'?: string;
}

export const CreateIssueRequestDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateIssueRequestDtoSeverityEnum = typeof CreateIssueRequestDtoSeverityEnum[keyof typeof CreateIssueRequestDtoSeverityEnum];

/**
 * 
 * @export
 * @interface CreateIssueResponseDto
 */
export interface CreateIssueResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateIssueResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueResponseDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface CreateIssueSubtypeRequestDto
 */
export interface CreateIssueSubtypeRequestDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof CreateIssueSubtypeRequestDto
     */
    'issueTypeManagers'?: Array<UserDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueSubtypeRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueSubtypeRequestDto
     */
    'issueTypeId': string;
}
/**
 * 
 * @export
 * @interface CreateIssueTemplateRequestDto
 */
export interface CreateIssueTemplateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'severity'?: CreateIssueTemplateRequestDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateIssueTemplateRequestDto
     */
    'isAutomatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'executionType': CreateIssueTemplateRequestDtoExecutionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'issueSubtypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateIssueTemplateRequestDto
     */
    'managerId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateIssueTemplateRequestDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {Array<CreateActionTemplateDto>}
     * @memberof CreateIssueTemplateRequestDto
     */
    'actions': Array<CreateActionTemplateDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateIssueTemplateRequestDto
     */
    'govmapGroups': Array<string>;
}

export const CreateIssueTemplateRequestDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateIssueTemplateRequestDtoSeverityEnum = typeof CreateIssueTemplateRequestDtoSeverityEnum[keyof typeof CreateIssueTemplateRequestDtoSeverityEnum];
export const CreateIssueTemplateRequestDtoExecutionTypeEnum = {
    Parallel: 'parallel',
    Sequential: 'sequential'
} as const;

export type CreateIssueTemplateRequestDtoExecutionTypeEnum = typeof CreateIssueTemplateRequestDtoExecutionTypeEnum[keyof typeof CreateIssueTemplateRequestDtoExecutionTypeEnum];

/**
 * 
 * @export
 * @interface CreateSLARequestDto
 */
export interface CreateSLARequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSLARequestDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLARequestDto
     */
    'issueSubtypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLARequestDto
     */
    'severity': CreateSLARequestDtoSeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateSLARequestDto
     */
    'slaDays': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLARequestDto
     */
    'maxDueDate': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLARequestDto
     */
    'escalationDays': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateSLARequestDto
     */
    'reminderDays'?: Array<number>;
}

export const CreateSLARequestDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateSLARequestDtoSeverityEnum = typeof CreateSLARequestDtoSeverityEnum[keyof typeof CreateSLARequestDtoSeverityEnum];

/**
 * 
 * @export
 * @interface CreateSLAResponseDto
 */
export interface CreateSLAResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'issueSubtypeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'severity': CreateSLAResponseDtoSeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAResponseDto
     */
    'slaDays': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAResponseDto
     */
    'maxDueDate': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSLAResponseDto
     */
    'escalationDays': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateSLAResponseDto
     */
    'reminderDays': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSLAResponseDto
     */
    'deletedAt': string | null;
}

export const CreateSLAResponseDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type CreateSLAResponseDtoSeverityEnum = typeof CreateSLAResponseDtoSeverityEnum[keyof typeof CreateSLAResponseDtoSeverityEnum];

/**
 * 
 * @export
 * @interface CreatedIssuesDto
 */
export interface CreatedIssuesDto {
    /**
     * 
     * @type {number}
     * @memberof CreatedIssuesDto
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof CreatedIssuesDto
     */
    'open': number;
    /**
     * 
     * @type {number}
     * @memberof CreatedIssuesDto
     */
    'inProgress': number;
}
/**
 * @type CreatorArrayOrSingleString
 * @export
 */
export type CreatorArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface DeclineActionRequestDto
 */
export interface DeclineActionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DeclineActionRequestDto
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<SaveActionAttachmentDto>}
     * @memberof DeclineActionRequestDto
     */
    'attachments': Array<SaveActionAttachmentDto>;
}
/**
 * 
 * @export
 * @interface DeclineIssueRequestDto
 */
export interface DeclineIssueRequestDto {
    /**
     * 
     * @type {Array<DeclinedActionDto>}
     * @memberof DeclineIssueRequestDto
     */
    'declinedActions': Array<DeclinedActionDto>;
}
/**
 * 
 * @export
 * @interface DeclinedActionDto
 */
export interface DeclinedActionDto {
    /**
     * 
     * @type {string}
     * @memberof DeclinedActionDto
     */
    'actionId': string;
    /**
     * 
     * @type {string}
     * @memberof DeclinedActionDto
     */
    'reason': string;
    /**
     * 
     * @type {Array<SaveActionAttachmentDto>}
     * @memberof DeclinedActionDto
     */
    'attachments'?: Array<SaveActionAttachmentDto>;
}
/**
 * 
 * @export
 * @interface DeleteSLAsRequestDto
 */
export interface DeleteSLAsRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteSLAsRequestDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DiscardIssueRequestDto
 */
export interface DiscardIssueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DiscardIssueRequestDto
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscardIssueRequestDto
     */
    'usersToNotify': Array<string>;
}
/**
 * @type EmailArrayOrSingleString
 * @export
 */
export type EmailArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface EntityNameDto
 */
export interface EntityNameDto {
    /**
     * 
     * @type {string}
     * @memberof EntityNameDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface EntityNamesFilteringDtoOptions
 */
export interface EntityNamesFilteringDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof EntityNamesFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * 
 * @export
 * @interface EntityTitleDto
 */
export interface EntityTitleDto {
    /**
     * 
     * @type {string}
     * @memberof EntityTitleDto
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface EntityTitlesFilteringDtoOptions
 */
export interface EntityTitlesFilteringDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof EntityTitlesFilteringDtoOptions
     */
    'searchTerm'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityTitlesFilteringDtoOptions
     */
    'isActionTitle'?: boolean;
}
/**
 * 
 * @export
 * @interface ExtendedActionDto
 */
export interface ExtendedActionDto {
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'issueId': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'status': ExtendedActionDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedActionDto
     */
    'dueDate': Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ExtendedActionDto
     */
    'deletedAt': Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'slugId': string;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ExtendedActionDto
     */
    'owner': MinimalUserDto;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof ExtendedActionDto
     */
    'approver': MinimalUserDto;
    /**
     * 
     * @type {Array<ActionGovmapGroupDto>}
     * @memberof ExtendedActionDto
     */
    'govmapGroups': Array<ActionGovmapGroupDto>;
    /**
     * 
     * @type {string}
     * @memberof ExtendedActionDto
     */
    'approvalStatus': ExtendedActionDtoApprovalStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ExtendedActionDto
     */
    'sequence': number;
    /**
     * 
     * @type {Array<AttachmentResponseDto>}
     * @memberof ExtendedActionDto
     */
    'attachments': Array<AttachmentResponseDto>;
}

export const ExtendedActionDtoStatusEnum = {
    Draft: 'action-draft',
    Pending: 'action-pending',
    Open: 'action-open',
    InProgress: 'action-in-progress',
    ToBeApproved: 'action-to-be-approved',
    Completed: 'action-completed',
    Discarded: 'action-discarded'
} as const;

export type ExtendedActionDtoStatusEnum = typeof ExtendedActionDtoStatusEnum[keyof typeof ExtendedActionDtoStatusEnum];
export const ExtendedActionDtoApprovalStatusEnum = {
    NotSet: 'not-set',
    WaitingForApproval: 'waiting-for-approval',
    Approved: 'approved',
    Denied: 'denied'
} as const;

export type ExtendedActionDtoApprovalStatusEnum = typeof ExtendedActionDtoApprovalStatusEnum[keyof typeof ExtendedActionDtoApprovalStatusEnum];

/**
 * 
 * @export
 * @interface FinishActionDto
 */
export interface FinishActionDto {
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof FinishActionDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}
/**
 * 
 * @export
 * @interface FlattenedIssueTypeDto
 */
export interface FlattenedIssueTypeDto {
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeDto
     */
    'issueTypeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeDto
     */
    'issueTypeName': string | null;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeDto
     */
    'issueSubtypeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeDto
     */
    'issueSubtypeName': string | null;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof FlattenedIssueTypeDto
     */
    'createdBy': MinimalUserDto | null;
    /**
     * 
     * @type {Array<MinimalUserDto>}
     * @memberof FlattenedIssueTypeDto
     */
    'managers': Array<MinimalUserDto>;
}
/**
 * 
 * @export
 * @interface FlattenedIssueTypeFilteringDtoOptions
 */
export interface FlattenedIssueTypeFilteringDtoOptions {
    /**
     * 
     * @type {IssueTypeIdArrayOrSingleString}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'issueTypeId'?: IssueTypeIdArrayOrSingleString;
    /**
     * 
     * @type {IssueSubtypeIdArrayOrSingleString}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'issueSubtypeId'?: IssueSubtypeIdArrayOrSingleString;
    /**
     * 
     * @type {ManagersArrayOrSingleString}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'managers'?: ManagersArrayOrSingleString;
    /**
     * 
     * @type {AddedByArrayOrSingleString}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'addedBy'?: AddedByArrayOrSingleString;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'addedAtRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'addedAtRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * 
 * @export
 * @interface FlattenedIssueTypeSortingDtoOptions
 */
export interface FlattenedIssueTypeSortingDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeSortingDtoOptions
     */
    'issueType'?: FlattenedIssueTypeSortingDtoOptionsIssueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeSortingDtoOptions
     */
    'issueSubtype'?: FlattenedIssueTypeSortingDtoOptionsIssueSubtypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeSortingDtoOptions
     */
    'manager'?: FlattenedIssueTypeSortingDtoOptionsManagerEnum;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeSortingDtoOptions
     */
    'addedBy'?: FlattenedIssueTypeSortingDtoOptionsAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof FlattenedIssueTypeSortingDtoOptions
     */
    'addedAt'?: FlattenedIssueTypeSortingDtoOptionsAddedAtEnum;
}

export const FlattenedIssueTypeSortingDtoOptionsIssueTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type FlattenedIssueTypeSortingDtoOptionsIssueTypeEnum = typeof FlattenedIssueTypeSortingDtoOptionsIssueTypeEnum[keyof typeof FlattenedIssueTypeSortingDtoOptionsIssueTypeEnum];
export const FlattenedIssueTypeSortingDtoOptionsIssueSubtypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type FlattenedIssueTypeSortingDtoOptionsIssueSubtypeEnum = typeof FlattenedIssueTypeSortingDtoOptionsIssueSubtypeEnum[keyof typeof FlattenedIssueTypeSortingDtoOptionsIssueSubtypeEnum];
export const FlattenedIssueTypeSortingDtoOptionsManagerEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type FlattenedIssueTypeSortingDtoOptionsManagerEnum = typeof FlattenedIssueTypeSortingDtoOptionsManagerEnum[keyof typeof FlattenedIssueTypeSortingDtoOptionsManagerEnum];
export const FlattenedIssueTypeSortingDtoOptionsAddedByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type FlattenedIssueTypeSortingDtoOptionsAddedByEnum = typeof FlattenedIssueTypeSortingDtoOptionsAddedByEnum[keyof typeof FlattenedIssueTypeSortingDtoOptionsAddedByEnum];
export const FlattenedIssueTypeSortingDtoOptionsAddedAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type FlattenedIssueTypeSortingDtoOptionsAddedAtEnum = typeof FlattenedIssueTypeSortingDtoOptionsAddedAtEnum[keyof typeof FlattenedIssueTypeSortingDtoOptionsAddedAtEnum];

/**
 * 
 * @export
 * @interface FlattenedIssueTypes200Response
 */
export interface FlattenedIssueTypes200Response {
    /**
     * 
     * @type {Array<FlattenedIssueTypeDto>}
     * @memberof FlattenedIssueTypes200Response
     */
    'data': Array<FlattenedIssueTypeDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof FlattenedIssueTypes200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface FlattenedIssueTypes200ResponseAllOf
 */
export interface FlattenedIssueTypes200ResponseAllOf {
    /**
     * 
     * @type {Array<FlattenedIssueTypeDto>}
     * @memberof FlattenedIssueTypes200ResponseAllOf
     */
    'data'?: Array<FlattenedIssueTypeDto>;
}
/**
 * 
 * @export
 * @interface GetCurrentUserRolesResponseDto
 */
export interface GetCurrentUserRolesResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasOwnedActions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasOwnedIssues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasApprovableActions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasApprovableIssues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasManagedIssues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasManagedIssueTypes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'hasCreatedIssues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCurrentUserRolesResponseDto
     */
    'isAdmin': boolean;
}
/**
 * 
 * @export
 * @interface GetEntityNames200Response
 */
export interface GetEntityNames200Response {
    /**
     * 
     * @type {Array<EntityNameDto>}
     * @memberof GetEntityNames200Response
     */
    'data': Array<EntityNameDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof GetEntityNames200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface GetEntityNames200ResponseAllOf
 */
export interface GetEntityNames200ResponseAllOf {
    /**
     * 
     * @type {Array<EntityNameDto>}
     * @memberof GetEntityNames200ResponseAllOf
     */
    'data'?: Array<EntityNameDto>;
}
/**
 * 
 * @export
 * @interface GetEntityTitles200Response
 */
export interface GetEntityTitles200Response {
    /**
     * 
     * @type {Array<EntityTitleDto>}
     * @memberof GetEntityTitles200Response
     */
    'data': Array<EntityTitleDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof GetEntityTitles200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface GetEntityTitles200ResponseAllOf
 */
export interface GetEntityTitles200ResponseAllOf {
    /**
     * 
     * @type {Array<EntityTitleDto>}
     * @memberof GetEntityTitles200ResponseAllOf
     */
    'data'?: Array<EntityTitleDto>;
}
/**
 * 
 * @export
 * @interface GetGovMapGroupsResponseDto
 */
export interface GetGovMapGroupsResponseDto {
    /**
     * 
     * @type {Array<GovMapGroupDto>}
     * @memberof GetGovMapGroupsResponseDto
     */
    'children': Array<GovMapGroupDto>;
    /**
     * 
     * @type {string}
     * @memberof GetGovMapGroupsResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetGovMapGroupsResponseDto
     */
    'name': string;
    /**
     * 
     * @type {Date}
     * @memberof GetGovMapGroupsResponseDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof GetGovMapGroupsResponseDto
     */
    'updatedAt': Date;
    /**
     * 
     * @type {string}
     * @memberof GetGovMapGroupsResponseDto
     */
    'parentGroupId': string | null;
}
/**
 * 
 * @export
 * @interface GetIssueActionCount200Response
 */
export interface GetIssueActionCount200Response {
    /**
     * 
     * @type {Array<IssueActionCountDto>}
     * @memberof GetIssueActionCount200Response
     */
    'data': Array<IssueActionCountDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof GetIssueActionCount200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface GetIssueActionCount200ResponseAllOf
 */
export interface GetIssueActionCount200ResponseAllOf {
    /**
     * 
     * @type {Array<IssueActionCountDto>}
     * @memberof GetIssueActionCount200ResponseAllOf
     */
    'data'?: Array<IssueActionCountDto>;
}
/**
 * 
 * @export
 * @interface GetIssueResponseDto
 */
export interface GetIssueResponseDto {
    /**
     * 
     * @type {GetIssueResponseDtoCategory}
     * @memberof GetIssueResponseDto
     * @deprecated
     */
    'category'?: GetIssueResponseDtoCategory;
    /**
     * 
     * @type {GetIssueResponseDtoSubcategory}
     * @memberof GetIssueResponseDto
     * @deprecated
     */
    'subcategory'?: GetIssueResponseDtoSubcategory;
    /**
     * 
     * @type {Array<IssueGovmapGroupDto>}
     * @memberof GetIssueResponseDto
     */
    'govmapGroups'?: Array<IssueGovmapGroupDto>;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'slaStatus': GetIssueResponseDtoSlaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'actionProgress': GetIssueResponseDtoActionProgressEnum;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'approvalStatus': GetIssueResponseDtoApprovalStatusEnum;
    /**
     * 
     * @type {Array<AttachmentResponseDto>}
     * @memberof GetIssueResponseDto
     */
    'attachments'?: Array<AttachmentResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'severity'?: GetIssueResponseDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'executionType': GetIssueResponseDtoExecutionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'description'?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetIssueResponseDto
     */
    'dueDate'?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssueResponseDto
     */
    'isWorkflowBlocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'title': string;
    /**
     * 
     * @type {MinimalIssueTypeDto}
     * @memberof GetIssueResponseDto
     */
    'issueType'?: MinimalIssueTypeDto;
    /**
     * 
     * @type {MinimalIssueSubtypeDto}
     * @memberof GetIssueResponseDto
     */
    'issueSubtype'?: MinimalIssueSubtypeDto | null;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof GetIssueResponseDto
     */
    'owner': AuthUserDto;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof GetIssueResponseDto
     */
    'approver'?: AuthUserDto;
    /**
     * 
     * @type {Date}
     * @memberof GetIssueResponseDto
     */
    'deletedAt'?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'status'?: GetIssueResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<AuthUserDto>}
     * @memberof GetIssueResponseDto
     */
    'managers'?: Array<AuthUserDto>;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof GetIssueResponseDto
     */
    'creator'?: AuthUserDto;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof GetIssueResponseDto
     */
    'manager'?: AuthUserDto;
    /**
     * 
     * @type {Array<ActionDto>}
     * @memberof GetIssueResponseDto
     */
    'actions': Array<ActionDto>;
    /**
     * 
     * @type {IssueSourceDto}
     * @memberof GetIssueResponseDto
     */
    'source'?: IssueSourceDto | null;
    /**
     * 
     * @type {IssueTimelineDto}
     * @memberof GetIssueResponseDto
     */
    'slaEvent': IssueTimelineDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetIssueResponseDto
     */
    'slaDays': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'selectedTemplate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetIssueResponseDto
     */
    'slaDueDays': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetIssueResponseDto
     */
    'maxDueDate': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetIssueResponseDto
     */
    'escalationDays': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetIssueResponseDto
     */
    'reminderDays': Array<number> | null;
    /**
     * 
     * @type {Array<IssueTimelineDto>}
     * @memberof GetIssueResponseDto
     */
    'timelineEvents': Array<IssueTimelineDto>;
    /**
     * 
     * @type {number}
     * @memberof GetIssueResponseDto
     */
    'actionCount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDto
     */
    'updatedAt': string;
}

export const GetIssueResponseDtoSlaStatusEnum = {
    Sla: 'sla',
    Overdue: 'overdue',
    NoProblem: 'no-problem',
    SlaReached: 'sla-reached'
} as const;

export type GetIssueResponseDtoSlaStatusEnum = typeof GetIssueResponseDtoSlaStatusEnum[keyof typeof GetIssueResponseDtoSlaStatusEnum];
export const GetIssueResponseDtoActionProgressEnum = {
    Blank: 'blank',
    NotInitiated: 'not-initiated',
    Initiated: 'initiated',
    Ongoing: 'ongoing',
    Completed: 'completed',
    Discarded: 'discarded'
} as const;

export type GetIssueResponseDtoActionProgressEnum = typeof GetIssueResponseDtoActionProgressEnum[keyof typeof GetIssueResponseDtoActionProgressEnum];
export const GetIssueResponseDtoApprovalStatusEnum = {
    NotSet: 'not-set',
    WaitingForApproval: 'waiting-for-approval',
    Approved: 'approved',
    Denied: 'denied'
} as const;

export type GetIssueResponseDtoApprovalStatusEnum = typeof GetIssueResponseDtoApprovalStatusEnum[keyof typeof GetIssueResponseDtoApprovalStatusEnum];
export const GetIssueResponseDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type GetIssueResponseDtoSeverityEnum = typeof GetIssueResponseDtoSeverityEnum[keyof typeof GetIssueResponseDtoSeverityEnum];
export const GetIssueResponseDtoExecutionTypeEnum = {
    Parallel: 'parallel',
    Sequential: 'sequential'
} as const;

export type GetIssueResponseDtoExecutionTypeEnum = typeof GetIssueResponseDtoExecutionTypeEnum[keyof typeof GetIssueResponseDtoExecutionTypeEnum];
export const GetIssueResponseDtoStatusEnum = {
    Open: 'issue-open',
    InProgress: 'issue-in-progress',
    ToBeApproved: 'issue-to-be-approved',
    Closed: 'issue-closed',
    Discarded: 'issue-discarded'
} as const;

export type GetIssueResponseDtoStatusEnum = typeof GetIssueResponseDtoStatusEnum[keyof typeof GetIssueResponseDtoStatusEnum];

/**
 * Deprecated, use issueType instead
 * @export
 * @interface GetIssueResponseDtoCategory
 */
export interface GetIssueResponseDtoCategory {
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDtoCategory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDtoCategory
     */
    'name': GetIssueResponseDtoCategoryNameEnum;
}

export const GetIssueResponseDtoCategoryNameEnum = {
    AuditFinding: 'audit-finding',
    ControlDeficiency: 'control-deficiency',
    Issue: 'issue',
    Incident: 'incident',
    Exception: 'exception'
} as const;

export type GetIssueResponseDtoCategoryNameEnum = typeof GetIssueResponseDtoCategoryNameEnum[keyof typeof GetIssueResponseDtoCategoryNameEnum];

/**
 * Deprecated, use issueSubtype instead
 * @export
 * @interface GetIssueResponseDtoSubcategory
 */
export interface GetIssueResponseDtoSubcategory {
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDtoSubcategory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueResponseDtoSubcategory
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GetIssueSLAs200Response
 */
export interface GetIssueSLAs200Response {
    /**
     * 
     * @type {Array<IssueSLAsDto>}
     * @memberof GetIssueSLAs200Response
     */
    'data': Array<IssueSLAsDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof GetIssueSLAs200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface GetIssueSLAs200ResponseAllOf
 */
export interface GetIssueSLAs200ResponseAllOf {
    /**
     * 
     * @type {Array<IssueSLAsDto>}
     * @memberof GetIssueSLAs200ResponseAllOf
     */
    'data'?: Array<IssueSLAsDto>;
}
/**
 * 
 * @export
 * @interface GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
 */
export interface GetIssueTemplateByIssueTypeIssueSubtypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'isAutomatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'severity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'managerId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {Array<ActionWithOwnerAndApproverDto>}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'actions': Array<ActionWithOwnerAndApproverDto>;
    /**
     * 
     * @type {Array<GovMapGroupWithoutChildrenDto>}
     * @memberof GetIssueTemplateByIssueTypeIssueSubtypeResponseDto
     */
    'govmapGroups'?: Array<GovMapGroupWithoutChildrenDto>;
}
/**
 * 
 * @export
 * @interface GetIssueTemplateResponseDto
 */
export interface GetIssueTemplateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'severity'?: GetIssueTemplateResponseDtoSeverityEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIssueTemplateResponseDto
     */
    'govmapGroups': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'title': string;
    /**
     * 
     * @type {IdNamePropertyDto}
     * @memberof GetIssueTemplateResponseDto
     */
    'issueType': IdNamePropertyDto;
    /**
     * 
     * @type {IdNameOptionalPropertyDto}
     * @memberof GetIssueTemplateResponseDto
     */
    'issueSubtype'?: IdNameOptionalPropertyDto;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'issueTypeConfigId': string;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'executionType': GetIssueTemplateResponseDtoExecutionTypeEnum;
    /**
     * 
     * @type {IdNamePropertyDto}
     * @memberof GetIssueTemplateResponseDto
     */
    'addedBy': IdNamePropertyDto;
    /**
     * 
     * @type {string}
     * @memberof GetIssueTemplateResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssueTemplateResponseDto
     */
    'isAutomatic': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetIssueTemplateResponseDto
     */
    'dueDate': number | null;
}

export const GetIssueTemplateResponseDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type GetIssueTemplateResponseDtoSeverityEnum = typeof GetIssueTemplateResponseDtoSeverityEnum[keyof typeof GetIssueTemplateResponseDtoSeverityEnum];
export const GetIssueTemplateResponseDtoExecutionTypeEnum = {
    Parallel: 'parallel',
    Sequential: 'sequential'
} as const;

export type GetIssueTemplateResponseDtoExecutionTypeEnum = typeof GetIssueTemplateResponseDtoExecutionTypeEnum[keyof typeof GetIssueTemplateResponseDtoExecutionTypeEnum];

/**
 * 
 * @export
 * @interface GetIssuesStatisticsResponseDto
 */
export interface GetIssuesStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof GetIssuesStatisticsResponseDto
     */
    'total'?: number;
    /**
     * 
     * @type {StatusStatisticsDto}
     * @memberof GetIssuesStatisticsResponseDto
     */
    'status'?: StatusStatisticsDto;
    /**
     * 
     * @type {SeverityStatisticsDto}
     * @memberof GetIssuesStatisticsResponseDto
     */
    'severity'?: SeverityStatisticsDto;
}
/**
 * 
 * @export
 * @interface GetQuickFilterStatisticsResponseDto
 */
export interface GetQuickFilterStatisticsResponseDto {
    /**
     * 
     * @type {QuickFilterNumbersDto}
     * @memberof GetQuickFilterStatisticsResponseDto
     */
    'quickFilterNumbers': QuickFilterNumbersDto;
    /**
     * 
     * @type {ColumnFiltersDto}
     * @memberof GetQuickFilterStatisticsResponseDto
     */
    'columnFilters': ColumnFiltersDto;
}
/**
 * 
 * @export
 * @interface GetUserResponseDto
 */
export interface GetUserResponseDto {
    /**
     * Feature flags as a record of flag names to flag objects
     * @type {{ [key: string]: GetUserResponseDtoFeatureFlagsValue; }}
     * @memberof GetUserResponseDto
     */
    'featureFlags'?: { [key: string]: GetUserResponseDtoFeatureFlagsValue; };
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'timezone': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'locale': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'dateFormat': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponseDto
     */
    'termsOfService': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'userType': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'initials': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'highbondId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface GetUserResponseDtoFeatureFlagsValue
 */
export interface GetUserResponseDtoFeatureFlagsValue {
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponseDtoFeatureFlagsValue
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDtoFeatureFlagsValue
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GetUserRolesResponseDto
 */
export interface GetUserRolesResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isIssueTypeManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isCreator': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isApprover': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isActionOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserRolesResponseDto
     */
    'isActionApprover': boolean;
}
/**
 * 
 * @export
 * @interface GovMapGroupDto
 */
export interface GovMapGroupDto {
    /**
     * 
     * @type {Date}
     * @memberof GovMapGroupDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof GovMapGroupDto
     */
    'updatedAt': Date;
    /**
     * 
     * @type {Array<GovMapGroupDto>}
     * @memberof GovMapGroupDto
     */
    'children': Array<GovMapGroupDto>;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupDto
     */
    'parentGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupDto
     */
    'parentGroupName'?: string | null;
}
/**
 * 
 * @export
 * @interface GovMapGroupWithoutChildrenDto
 */
export interface GovMapGroupWithoutChildrenDto {
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupWithoutChildrenDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupWithoutChildrenDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupWithoutChildrenDto
     */
    'parentGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GovMapGroupWithoutChildrenDto
     */
    'parentGroupName'?: string | null;
}
/**
 * 
 * @export
 * @interface GovmapGroupFilteringDtoOptions
 */
export interface GovmapGroupFilteringDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof GovmapGroupFilteringDtoOptions
     */
    'searchTerm'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GovmapGroupFilteringDtoOptions
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GovmapGroupSortingDtoOptions
 */
export interface GovmapGroupSortingDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof GovmapGroupSortingDtoOptions
     */
    'name'?: GovmapGroupSortingDtoOptionsNameEnum;
}

export const GovmapGroupSortingDtoOptionsNameEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type GovmapGroupSortingDtoOptionsNameEnum = typeof GovmapGroupSortingDtoOptionsNameEnum[keyof typeof GovmapGroupSortingDtoOptionsNameEnum];

/**
 * @type IdArrayOrSingleString
 * @export
 */
export type IdArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface IdNameOptionalPropertyDto
 */
export interface IdNameOptionalPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IdNameOptionalPropertyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IdNameOptionalPropertyDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface IdNamePropertyDto
 */
export interface IdNamePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IdNamePropertyDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IdNamePropertyDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface IncomingIssuesDto
 */
export interface IncomingIssuesDto {
    /**
     * 
     * @type {number}
     * @memberof IncomingIssuesDto
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof IncomingIssuesDto
     */
    'unAssigned': number;
}
/**
 * 
 * @export
 * @interface InitiateWorkflowDto
 */
export interface InitiateWorkflowDto {
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'severity': InitiateWorkflowDtoSeverityEnum;
    /**
     * 
     * @type {Date}
     * @memberof InitiateWorkflowDto
     */
    'dueDate': Date;
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'approverId': string;
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'executionType': InitiateWorkflowDtoExecutionTypeEnum;
    /**
     * 
     * @type {Array<CreateActionDto>}
     * @memberof InitiateWorkflowDto
     */
    'actions': Array<CreateActionDto>;
    /**
     * 
     * @type {string}
     * @memberof InitiateWorkflowDto
     */
    'selectedTemplateId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InitiateWorkflowDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof InitiateWorkflowDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}

export const InitiateWorkflowDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type InitiateWorkflowDtoSeverityEnum = typeof InitiateWorkflowDtoSeverityEnum[keyof typeof InitiateWorkflowDtoSeverityEnum];
export const InitiateWorkflowDtoExecutionTypeEnum = {
    Parallel: 'parallel',
    Sequential: 'sequential'
} as const;

export type InitiateWorkflowDtoExecutionTypeEnum = typeof InitiateWorkflowDtoExecutionTypeEnum[keyof typeof InitiateWorkflowDtoExecutionTypeEnum];

/**
 * 
 * @export
 * @interface IssueActionCountDto
 */
export interface IssueActionCountDto {
    /**
     * 
     * @type {number}
     * @memberof IssueActionCountDto
     */
    'actionCount': number;
}
/**
 * 
 * @export
 * @interface IssueActionCountFilteringDtoOptions
 */
export interface IssueActionCountFilteringDtoOptions {
    /**
     * 
     * @type {ActionCountArrayOrSingleString}
     * @memberof IssueActionCountFilteringDtoOptions
     */
    'actionCount'?: ActionCountArrayOrSingleString;
    /**
     * 
     * @type {string}
     * @memberof IssueActionCountFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * 
 * @export
 * @interface IssueFilteringDtoOptions
 */
export interface IssueFilteringDtoOptions {
    /**
     * 
     * @type {CodeArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'code'?: CodeArrayOrSingleString;
    /**
     * 
     * @type {IssueTypeArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'issueType'?: IssueTypeArrayOrSingleString;
    /**
     * 
     * @type {IssueSubtypeArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'issueSubtype'?: IssueSubtypeArrayOrSingleString;
    /**
     * 
     * @type {OwnerArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'owner'?: OwnerArrayOrSingleString;
    /**
     * 
     * @type {ApproverArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'approver'?: ApproverArrayOrSingleString;
    /**
     * 
     * @type {CreatorArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'creator'?: CreatorArrayOrSingleString;
    /**
     * 
     * @type {ManagerArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'manager'?: ManagerArrayOrSingleString;
    /**
     * 
     * @type {SlaDueDaysArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'slaDueDays'?: SlaDueDaysArrayOrSingleString;
    /**
     * 
     * @type {ActionOwnerArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'actionOwner'?: ActionOwnerArrayOrSingleString;
    /**
     * 
     * @type {ActionApproverArrayOrSingleString}
     * @memberof IssueFilteringDtoOptions
     */
    'actionApprover'?: ActionApproverArrayOrSingleString;
    /**
     * 
     * @type {IssueFilteringDtoOptionsStatus}
     * @memberof IssueFilteringDtoOptions
     */
    'status'?: IssueFilteringDtoOptionsStatus;
    /**
     * 
     * @type {IssueTemplateFilteringDtoOptionsSeverity}
     * @memberof IssueFilteringDtoOptions
     */
    'severity'?: IssueTemplateFilteringDtoOptionsSeverity;
    /**
     * 
     * @type {IssueFilteringDtoOptionsActionCount}
     * @memberof IssueFilteringDtoOptions
     */
    'actionCount'?: IssueFilteringDtoOptionsActionCount;
    /**
     * 
     * @type {IssueFilteringDtoOptionsActionProgress}
     * @memberof IssueFilteringDtoOptions
     */
    'actionProgress'?: IssueFilteringDtoOptionsActionProgress;
    /**
     * 
     * @type {IssueFilteringDtoOptionsActionStatus}
     * @memberof IssueFilteringDtoOptions
     */
    'actionStatus'?: IssueFilteringDtoOptionsActionStatus;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'title'?: object;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'sourceApplication'?: object;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'sourceEntityName'?: object;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'sourceEntityId'?: object;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'slaStatus'?: object;
    /**
     * 
     * @type {object}
     * @memberof IssueFilteringDtoOptions
     */
    'actionTitle'?: object;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'createdAtRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'createdAtRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'updatedAtRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'updatedAtRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'dueDateRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'dueDateRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'actionDueDateRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'actionDueDateRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * @type IssueFilteringDtoOptionsActionCount
 * @export
 */
export type IssueFilteringDtoOptionsActionCount = Array<number> | number;

/**
 * @type IssueFilteringDtoOptionsActionProgress
 * @export
 */
export type IssueFilteringDtoOptionsActionProgress = Array<string> | string;

/**
 * @type IssueFilteringDtoOptionsActionStatus
 * @export
 */
export type IssueFilteringDtoOptionsActionStatus = Array<string> | string;

/**
 * @type IssueFilteringDtoOptionsStatus
 * @export
 */
export type IssueFilteringDtoOptionsStatus = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueGovmapGroupDto
 */
export interface IssueGovmapGroupDto {
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'issueId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'id': string;
    /**
     * 
     * @type {Date}
     * @memberof IssueGovmapGroupDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof IssueGovmapGroupDto
     */
    'updatedAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof IssueGovmapGroupDto
     */
    'deletedAt': Date | null;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'parentGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueGovmapGroupDto
     */
    'parentGroupName': string | null;
}
/**
 * 
 * @export
 * @interface IssueResponseDto
 */
export interface IssueResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'severity': IssueResponseDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'status': IssueResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'slaStatus': IssueResponseDtoSlaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'actionProgress': IssueResponseDtoActionProgressEnum;
    /**
     * 
     * @type {MinimalIssueTypeDto}
     * @memberof IssueResponseDto
     */
    'issueType': MinimalIssueTypeDto | null;
    /**
     * 
     * @type {MinimalIssueSubtypeDto}
     * @memberof IssueResponseDto
     */
    'issueSubtype': MinimalIssueSubtypeDto | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof IssueResponseDto
     */
    'creator': MinimalUserDto;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof IssueResponseDto
     */
    'owner': MinimalUserDto | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof IssueResponseDto
     */
    'manager': MinimalUserDto | null;
    /**
     * 
     * @type {Array<MinimalUserDto>}
     * @memberof IssueResponseDto
     */
    'managers': Array<MinimalUserDto> | null;
    /**
     * 
     * @type {MinimalUserDto}
     * @memberof IssueResponseDto
     */
    'approver': MinimalUserDto | null;
    /**
     * 
     * @type {Array<ExtendedActionDto>}
     * @memberof IssueResponseDto
     */
    'actions': Array<ExtendedActionDto> | null;
    /**
     * 
     * @type {Array<IssueGovmapGroupDto>}
     * @memberof IssueResponseDto
     */
    'govmapGroups': Array<IssueGovmapGroupDto> | null;
    /**
     * 
     * @type {Array<IssueTimelineDto>}
     * @memberof IssueResponseDto
     */
    'timelineEvents': Array<IssueTimelineDto> | null;
    /**
     * 
     * @type {IssueTimelineDto}
     * @memberof IssueResponseDto
     */
    'slaEvent': IssueTimelineDto | null;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'code': string;
    /**
     * 
     * @type {Date}
     * @memberof IssueResponseDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {Date}
     * @memberof IssueResponseDto
     */
    'updatedAt': Date;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'ownerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'approverId': string | null;
    /**
     * 
     * @type {Date}
     * @memberof IssueResponseDto
     */
    'dueDate': Date | null;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'managerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseDto
     */
    'selectedTemplate': string | null;
    /**
     * 
     * @type {IssueResponseSourceDto}
     * @memberof IssueResponseDto
     */
    'source': IssueResponseSourceDto | null;
    /**
     * 
     * @type {number}
     * @memberof IssueResponseDto
     */
    'slaDays': number | null;
    /**
     * 
     * @type {number}
     * @memberof IssueResponseDto
     */
    'maxDueDate': number | null;
    /**
     * 
     * @type {number}
     * @memberof IssueResponseDto
     */
    'escalationDays': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof IssueResponseDto
     */
    'reminderDays': Array<number> | null;
    /**
     * 
     * @type {object}
     * @memberof IssueResponseDto
     */
    'slaDueDays': object;
    /**
     * 
     * @type {number}
     * @memberof IssueResponseDto
     */
    'actionCount': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof IssueResponseDto
     */
    'isIssueTypeManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IssueResponseDto
     */
    'isActionOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IssueResponseDto
     */
    'isActionApprover': boolean;
    /**
     * 
     * @type {OrganizationIdentificationDto}
     * @memberof IssueResponseDto
     */
    'organization': OrganizationIdentificationDto;
}

export const IssueResponseDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type IssueResponseDtoSeverityEnum = typeof IssueResponseDtoSeverityEnum[keyof typeof IssueResponseDtoSeverityEnum];
export const IssueResponseDtoStatusEnum = {
    Open: 'issue-open',
    InProgress: 'issue-in-progress',
    ToBeApproved: 'issue-to-be-approved',
    Closed: 'issue-closed',
    Discarded: 'issue-discarded'
} as const;

export type IssueResponseDtoStatusEnum = typeof IssueResponseDtoStatusEnum[keyof typeof IssueResponseDtoStatusEnum];
export const IssueResponseDtoSlaStatusEnum = {
    Sla: 'sla',
    Overdue: 'overdue',
    NoProblem: 'no-problem',
    SlaReached: 'sla-reached'
} as const;

export type IssueResponseDtoSlaStatusEnum = typeof IssueResponseDtoSlaStatusEnum[keyof typeof IssueResponseDtoSlaStatusEnum];
export const IssueResponseDtoActionProgressEnum = {
    Blank: 'blank',
    NotInitiated: 'not-initiated',
    Initiated: 'initiated',
    Ongoing: 'ongoing',
    Completed: 'completed',
    Discarded: 'discarded'
} as const;

export type IssueResponseDtoActionProgressEnum = typeof IssueResponseDtoActionProgressEnum[keyof typeof IssueResponseDtoActionProgressEnum];

/**
 * 
 * @export
 * @interface IssueResponseSourceDto
 */
export interface IssueResponseSourceDto {
    /**
     * 
     * @type {string}
     * @memberof IssueResponseSourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseSourceDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseSourceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueResponseSourceDto
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface IssueSLAsDto
 */
export interface IssueSLAsDto {
    /**
     * 
     * @type {number}
     * @memberof IssueSLAsDto
     */
    'slaDueDays': number;
}
/**
 * 
 * @export
 * @interface IssueSLAsFilteringDtoOptions
 */
export interface IssueSLAsFilteringDtoOptions {
    /**
     * 
     * @type {SlaDueDaysArrayOrSingleString}
     * @memberof IssueSLAsFilteringDtoOptions
     */
    'slaDueDays'?: SlaDueDaysArrayOrSingleString;
    /**
     * 
     * @type {string}
     * @memberof IssueSLAsFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * 
 * @export
 * @interface IssueSortingDtoOptions
 */
export interface IssueSortingDtoOptions {
    /**
     * Deprecated, use issueType instead
     * @type {string}
     * @memberof IssueSortingDtoOptions
     * @deprecated
     */
    'category'?: IssueSortingDtoOptionsCategoryEnum;
    /**
     * Deprecated, use issueSubtype instead
     * @type {string}
     * @memberof IssueSortingDtoOptions
     * @deprecated
     */
    'subcategory'?: IssueSortingDtoOptionsSubcategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'code'?: IssueSortingDtoOptionsCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'title'?: IssueSortingDtoOptionsTitleEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'issueType'?: IssueSortingDtoOptionsIssueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'issueSubtype'?: IssueSortingDtoOptionsIssueSubtypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'severity'?: IssueSortingDtoOptionsSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'status'?: IssueSortingDtoOptionsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'sourceApplication'?: IssueSortingDtoOptionsSourceApplicationEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'sourceEntityName'?: IssueSortingDtoOptionsSourceEntityNameEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'createdAt'?: IssueSortingDtoOptionsCreatedAtEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'updatedAt'?: IssueSortingDtoOptionsUpdatedAtEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'dueDate'?: IssueSortingDtoOptionsDueDateEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'owner'?: IssueSortingDtoOptionsOwnerEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'creator'?: IssueSortingDtoOptionsCreatorEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'manager'?: IssueSortingDtoOptionsManagerEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'slaDueDays'?: IssueSortingDtoOptionsSlaDueDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'actionCount'?: IssueSortingDtoOptionsActionCountEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSortingDtoOptions
     */
    'actionProgress'?: IssueSortingDtoOptionsActionProgressEnum;
}

export const IssueSortingDtoOptionsCategoryEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsCategoryEnum = typeof IssueSortingDtoOptionsCategoryEnum[keyof typeof IssueSortingDtoOptionsCategoryEnum];
export const IssueSortingDtoOptionsSubcategoryEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsSubcategoryEnum = typeof IssueSortingDtoOptionsSubcategoryEnum[keyof typeof IssueSortingDtoOptionsSubcategoryEnum];
export const IssueSortingDtoOptionsCodeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsCodeEnum = typeof IssueSortingDtoOptionsCodeEnum[keyof typeof IssueSortingDtoOptionsCodeEnum];
export const IssueSortingDtoOptionsTitleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsTitleEnum = typeof IssueSortingDtoOptionsTitleEnum[keyof typeof IssueSortingDtoOptionsTitleEnum];
export const IssueSortingDtoOptionsIssueTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsIssueTypeEnum = typeof IssueSortingDtoOptionsIssueTypeEnum[keyof typeof IssueSortingDtoOptionsIssueTypeEnum];
export const IssueSortingDtoOptionsIssueSubtypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsIssueSubtypeEnum = typeof IssueSortingDtoOptionsIssueSubtypeEnum[keyof typeof IssueSortingDtoOptionsIssueSubtypeEnum];
export const IssueSortingDtoOptionsSeverityEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsSeverityEnum = typeof IssueSortingDtoOptionsSeverityEnum[keyof typeof IssueSortingDtoOptionsSeverityEnum];
export const IssueSortingDtoOptionsStatusEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsStatusEnum = typeof IssueSortingDtoOptionsStatusEnum[keyof typeof IssueSortingDtoOptionsStatusEnum];
export const IssueSortingDtoOptionsSourceApplicationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsSourceApplicationEnum = typeof IssueSortingDtoOptionsSourceApplicationEnum[keyof typeof IssueSortingDtoOptionsSourceApplicationEnum];
export const IssueSortingDtoOptionsSourceEntityNameEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsSourceEntityNameEnum = typeof IssueSortingDtoOptionsSourceEntityNameEnum[keyof typeof IssueSortingDtoOptionsSourceEntityNameEnum];
export const IssueSortingDtoOptionsCreatedAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsCreatedAtEnum = typeof IssueSortingDtoOptionsCreatedAtEnum[keyof typeof IssueSortingDtoOptionsCreatedAtEnum];
export const IssueSortingDtoOptionsUpdatedAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsUpdatedAtEnum = typeof IssueSortingDtoOptionsUpdatedAtEnum[keyof typeof IssueSortingDtoOptionsUpdatedAtEnum];
export const IssueSortingDtoOptionsDueDateEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsDueDateEnum = typeof IssueSortingDtoOptionsDueDateEnum[keyof typeof IssueSortingDtoOptionsDueDateEnum];
export const IssueSortingDtoOptionsOwnerEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsOwnerEnum = typeof IssueSortingDtoOptionsOwnerEnum[keyof typeof IssueSortingDtoOptionsOwnerEnum];
export const IssueSortingDtoOptionsCreatorEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsCreatorEnum = typeof IssueSortingDtoOptionsCreatorEnum[keyof typeof IssueSortingDtoOptionsCreatorEnum];
export const IssueSortingDtoOptionsManagerEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsManagerEnum = typeof IssueSortingDtoOptionsManagerEnum[keyof typeof IssueSortingDtoOptionsManagerEnum];
export const IssueSortingDtoOptionsSlaDueDaysEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsSlaDueDaysEnum = typeof IssueSortingDtoOptionsSlaDueDaysEnum[keyof typeof IssueSortingDtoOptionsSlaDueDaysEnum];
export const IssueSortingDtoOptionsActionCountEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsActionCountEnum = typeof IssueSortingDtoOptionsActionCountEnum[keyof typeof IssueSortingDtoOptionsActionCountEnum];
export const IssueSortingDtoOptionsActionProgressEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueSortingDtoOptionsActionProgressEnum = typeof IssueSortingDtoOptionsActionProgressEnum[keyof typeof IssueSortingDtoOptionsActionProgressEnum];

/**
 * 
 * @export
 * @interface IssueSourceDto
 */
export interface IssueSourceDto {
    /**
     * 
     * @type {string}
     * @memberof IssueSourceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSourceDto
     */
    'entityType': IssueSourceDtoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueSourceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSourceDto
     */
    'link': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSourceDto
     */
    'app': IssueSourceDtoAppEnum;
}

export const IssueSourceDtoEntityTypeEnum = {
    Risk: 'risk',
    Audit: 'audit',
    Control: 'control',
    Process: 'process',
    Objective: 'objective',
    ControlAssessment: 'control-assessment',
    RiskMitigation: 'risk-mitigation',
    RiskAssessment: 'risk-assessment',
    Asset: 'asset',
    AssetFinding: 'asset-finding'
} as const;

export type IssueSourceDtoEntityTypeEnum = typeof IssueSourceDtoEntityTypeEnum[keyof typeof IssueSourceDtoEntityTypeEnum];
export const IssueSourceDtoAppEnum = {
    RiskManager: 'risk-manager',
    Audit: 'audit',
    InternalControls: 'internal-controls',
    IssueManagement: 'issue-management',
    AssetManager: 'asset-manager'
} as const;

export type IssueSourceDtoAppEnum = typeof IssueSourceDtoAppEnum[keyof typeof IssueSourceDtoAppEnum];

/**
 * @type IssueSubtypeArrayOrSingleString
 * @export
 */
export type IssueSubtypeArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueSubtypeDto
 */
export interface IssueSubtypeDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof IssueSubtypeDto
     */
    'issueTypeManagers'?: Array<UserDto>;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {MinimalIssueTypeDto}
     * @memberof IssueSubtypeDto
     */
    'issueType': MinimalIssueTypeDto | null;
}
/**
 * @type IssueSubtypeIdArrayOrSingleString
 * @export
 */
export type IssueSubtypeIdArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueSubtypeWithIssueTypeManagersDto
 */
export interface IssueSubtypeWithIssueTypeManagersDto {
    /**
     * 
     * @type {Array<AuthUserDto>}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'issueTypeManagers': Array<AuthUserDto>;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypeWithIssueTypeManagersDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface IssueSubtypes200Response
 */
export interface IssueSubtypes200Response {
    /**
     * 
     * @type {Array<IssueSubtypeDto>}
     * @memberof IssueSubtypes200Response
     */
    'data': Array<IssueSubtypeDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof IssueSubtypes200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface IssueSubtypes200ResponseAllOf
 */
export interface IssueSubtypes200ResponseAllOf {
    /**
     * 
     * @type {Array<IssueSubtypeDto>}
     * @memberof IssueSubtypes200ResponseAllOf
     */
    'data'?: Array<IssueSubtypeDto>;
}
/**
 * 
 * @export
 * @interface IssueSubtypesManagedByMeDto
 */
export interface IssueSubtypesManagedByMeDto {
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypesManagedByMeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypesManagedByMeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypesManagedByMeDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueSubtypesManagedByMeDto
     */
    'issueTypeName': string;
}
/**
 * 
 * @export
 * @interface IssueTemplateCreatedResponseDto
 */
export interface IssueTemplateCreatedResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateCreatedResponseDto
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateCreatedResponseDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateCreatedResponseDto
     */
    'issueSubtypeId'?: string | null;
}
/**
 * 
 * @export
 * @interface IssueTemplateDto
 */
export interface IssueTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'severity'?: IssueTemplateDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof IssueTemplateDto
     */
    'isAutomatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'issueSubtypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssueTemplateDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {Array<ActionTemplateDto>}
     * @memberof IssueTemplateDto
     */
    'actions': Array<ActionTemplateDto>;
    /**
     * 
     * @type {Array<GovMapGroupDto>}
     * @memberof IssueTemplateDto
     */
    'govmapGroups': Array<GovMapGroupDto>;
}

export const IssueTemplateDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type IssueTemplateDtoSeverityEnum = typeof IssueTemplateDtoSeverityEnum[keyof typeof IssueTemplateDtoSeverityEnum];

/**
 * 
 * @export
 * @interface IssueTemplateFilteringDtoOptions
 */
export interface IssueTemplateFilteringDtoOptions {
    /**
     * 
     * @type {TitleArrayOrSingleString}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'title'?: TitleArrayOrSingleString;
    /**
     * 
     * @type {IssueTypeArrayOrSingleString}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'issueType'?: IssueTypeArrayOrSingleString;
    /**
     * 
     * @type {IssueSubtypeArrayOrSingleString}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'issueSubtype'?: IssueSubtypeArrayOrSingleString;
    /**
     * 
     * @type {IssueTemplateFilteringDtoOptionsSeverity}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'severity'?: IssueTemplateFilteringDtoOptionsSeverity;
    /**
     * 
     * @type {AddedByArrayOrSingleString}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'addedBy'?: AddedByArrayOrSingleString;
    /**
     * 
     * @type {boolean}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'isAutomatic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'createdAtRangeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'createdAtRangeEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateFilteringDtoOptions
     */
    'searchTerm'?: string;
}
/**
 * @type IssueTemplateFilteringDtoOptionsSeverity
 * @export
 */
export type IssueTemplateFilteringDtoOptionsSeverity = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueTemplateSortingDtoOptions
 */
export interface IssueTemplateSortingDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'title'?: IssueTemplateSortingDtoOptionsTitleEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'issueType'?: IssueTemplateSortingDtoOptionsIssueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'issueSubtype'?: IssueTemplateSortingDtoOptionsIssueSubtypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'addedBy'?: IssueTemplateSortingDtoOptionsAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'createdAt'?: IssueTemplateSortingDtoOptionsCreatedAtEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'isAutomatic'?: IssueTemplateSortingDtoOptionsIsAutomaticEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateSortingDtoOptions
     */
    'severity'?: IssueTemplateSortingDtoOptionsSeverityEnum;
}

export const IssueTemplateSortingDtoOptionsTitleEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsTitleEnum = typeof IssueTemplateSortingDtoOptionsTitleEnum[keyof typeof IssueTemplateSortingDtoOptionsTitleEnum];
export const IssueTemplateSortingDtoOptionsIssueTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsIssueTypeEnum = typeof IssueTemplateSortingDtoOptionsIssueTypeEnum[keyof typeof IssueTemplateSortingDtoOptionsIssueTypeEnum];
export const IssueTemplateSortingDtoOptionsIssueSubtypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsIssueSubtypeEnum = typeof IssueTemplateSortingDtoOptionsIssueSubtypeEnum[keyof typeof IssueTemplateSortingDtoOptionsIssueSubtypeEnum];
export const IssueTemplateSortingDtoOptionsAddedByEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsAddedByEnum = typeof IssueTemplateSortingDtoOptionsAddedByEnum[keyof typeof IssueTemplateSortingDtoOptionsAddedByEnum];
export const IssueTemplateSortingDtoOptionsCreatedAtEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsCreatedAtEnum = typeof IssueTemplateSortingDtoOptionsCreatedAtEnum[keyof typeof IssueTemplateSortingDtoOptionsCreatedAtEnum];
export const IssueTemplateSortingDtoOptionsIsAutomaticEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsIsAutomaticEnum = typeof IssueTemplateSortingDtoOptionsIsAutomaticEnum[keyof typeof IssueTemplateSortingDtoOptionsIsAutomaticEnum];
export const IssueTemplateSortingDtoOptionsSeverityEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type IssueTemplateSortingDtoOptionsSeverityEnum = typeof IssueTemplateSortingDtoOptionsSeverityEnum[keyof typeof IssueTemplateSortingDtoOptionsSeverityEnum];

/**
 * 
 * @export
 * @interface IssueTemplateUpdatedResponseDto
 */
export interface IssueTemplateUpdatedResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'issueSubtypeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'isAutomatic': boolean;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'severity'?: IssueTemplateUpdatedResponseDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'dueDate'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {Array<ActionTemplateResponseDto>}
     * @memberof IssueTemplateUpdatedResponseDto
     */
    'actions': Array<ActionTemplateResponseDto>;
}

export const IssueTemplateUpdatedResponseDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type IssueTemplateUpdatedResponseDtoSeverityEnum = typeof IssueTemplateUpdatedResponseDtoSeverityEnum[keyof typeof IssueTemplateUpdatedResponseDtoSeverityEnum];

/**
 * 
 * @export
 * @interface IssueTemplates200Response
 */
export interface IssueTemplates200Response {
    /**
     * 
     * @type {Array<GetIssueTemplateResponseDto>}
     * @memberof IssueTemplates200Response
     */
    'data': Array<GetIssueTemplateResponseDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof IssueTemplates200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface IssueTemplates200ResponseAllOf
 */
export interface IssueTemplates200ResponseAllOf {
    /**
     * 
     * @type {Array<GetIssueTemplateResponseDto>}
     * @memberof IssueTemplates200ResponseAllOf
     */
    'data'?: Array<GetIssueTemplateResponseDto>;
}
/**
 * 
 * @export
 * @interface IssueTimelineDto
 */
export interface IssueTimelineDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineDto
     */
    'eventType': IssueTimelineDtoEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineDto
     */
    'eventAt': string;
    /**
     * 
     * @type {IssueTimelineEventDataDto}
     * @memberof IssueTimelineDto
     */
    'bodyData': IssueTimelineEventDataDto;
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineDto
     */
    'actorId': string;
}

export const IssueTimelineDtoEventTypeEnum = {
    IssueCreated: 'issue-created',
    IssueAssigned: 'issue-assigned',
    IssueClosed: 'issue-closed',
    IssueDiscarded: 'issue-discarded',
    IssueApproved: 'issue-approved',
    IssueDeclined: 'issue-declined',
    IssueEdited: 'issue-edited',
    ActionEdited: 'action-edited',
    ActionAdded: 'action-added',
    ActionDeleted: 'action-deleted',
    IssueToBeApproved: 'issue-to-be-approved',
    CommentAdded: 'comment-added',
    ActionCreated: 'action-created',
    ActionInitiated: 'action-initiated',
    ActionStarted: 'action-started',
    ActionCompleted: 'action-completed',
    ActionToBeApproved: 'action-to-be-approved',
    ActionApproved: 'action-approved',
    ActionRejected: 'action-rejected',
    ActionDiscarded: 'action-discarded',
    ActionOpened: 'action-opened',
    SlaDeactivated: 'sla-deactivated',
    SlaActivated: 'sla-activated',
    AttachmentDeleted: 'attachment-deleted',
    RelationshipAdded: 'relationship-added',
    RelationshipDeleted: 'relationship-deleted'
} as const;

export type IssueTimelineDtoEventTypeEnum = typeof IssueTimelineDtoEventTypeEnum[keyof typeof IssueTimelineDtoEventTypeEnum];

/**
 * 
 * @export
 * @interface IssueTimelineEventAttachmentDto
 */
export interface IssueTimelineEventAttachmentDto {
    /**
     * 
     * @type {Array<AttachmentResponseDto>}
     * @memberof IssueTimelineEventAttachmentDto
     */
    'value': Array<AttachmentResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineEventAttachmentDto
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface IssueTimelineEventDataDto
 */
export interface IssueTimelineEventDataDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineEventDataDto
     */
    'v': string;
    /**
     * 
     * @type {IssueTimelineEventDataParameterKeysDto}
     * @memberof IssueTimelineEventDataDto
     */
    'parameters': IssueTimelineEventDataParameterKeysDto;
}
/**
 * 
 * @export
 * @interface IssueTimelineEventDataParameterKeysDto
 */
export interface IssueTimelineEventDataParameterKeysDto {
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'timestamp': IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'actorName': IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'actorInitials'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueCode'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueOwnerName'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueOwnerId'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueDescription'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueStatus'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'actionTitle'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'issueComment'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'discardMessage'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'reason'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'editedField'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'editedFrom'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'editedTo'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventAttachmentDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'attachments'?: IssueTimelineEventAttachmentDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'actionId'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'relationshipType'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'relationshipObjectId'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'relationshipObjectName'?: IssueTimelineEventDataParameterValuesDto;
    /**
     * 
     * @type {IssueTimelineEventDataParameterValuesDto}
     * @memberof IssueTimelineEventDataParameterKeysDto
     */
    'relationshipObjectUrl'?: IssueTimelineEventDataParameterValuesDto;
}
/**
 * 
 * @export
 * @interface IssueTimelineEventDataParameterValuesDto
 */
export interface IssueTimelineEventDataParameterValuesDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTimelineEventDataParameterValuesDto
     */
    'value': string;
    /**
     * 
     * @type {object}
     * @memberof IssueTimelineEventDataParameterValuesDto
     */
    'type': object;
}
/**
 * @type IssueTypeArrayOrSingleString
 * @export
 */
export type IssueTypeArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueTypeDto
 */
export interface IssueTypeDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof IssueTypeDto
     */
    'issueTypeManagers': Array<UserDto>;
    /**
     * 
     * @type {Array<IssueSubtypeWithIssueTypeManagersDto>}
     * @memberof IssueTypeDto
     */
    'issueSubtypes': Array<IssueSubtypeWithIssueTypeManagersDto>;
    /**
     * 
     * @type {string}
     * @memberof IssueTypeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTypeDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTypeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTypeDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof IssueTypeDto
     */
    'mustBeSelectedWithIssueSubtypes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IssueTypeDto
     */
    'hasIssueSubtypes': boolean;
}
/**
 * @type IssueTypeIdArrayOrSingleString
 * @export
 */
export type IssueTypeIdArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface IssueTypes200Response
 */
export interface IssueTypes200Response {
    /**
     * 
     * @type {Array<IssueTypeDto>}
     * @memberof IssueTypes200Response
     */
    'data': Array<IssueTypeDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof IssueTypes200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface IssueTypes200ResponseAllOf
 */
export interface IssueTypes200ResponseAllOf {
    /**
     * 
     * @type {Array<IssueTypeDto>}
     * @memberof IssueTypes200ResponseAllOf
     */
    'data'?: Array<IssueTypeDto>;
}
/**
 * 
 * @export
 * @interface IssueTypesManagedByMeDto
 */
export interface IssueTypesManagedByMeDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTypesManagedByMeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTypesManagedByMeDto
     */
    'name': string;
    /**
     * 
     * @type {Array<IssueTypesRelatedIssueSubtypesDto>}
     * @memberof IssueTypesManagedByMeDto
     */
    'issueSubtypes': Array<IssueTypesRelatedIssueSubtypesDto>;
}
/**
 * 
 * @export
 * @interface IssueTypesRelatedIssueSubtypesDto
 */
export interface IssueTypesRelatedIssueSubtypesDto {
    /**
     * 
     * @type {string}
     * @memberof IssueTypesRelatedIssueSubtypesDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IssueTypesRelatedIssueSubtypesDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Issues200Response
 */
export interface Issues200Response {
    /**
     * 
     * @type {Array<GetIssueResponseDto>}
     * @memberof Issues200Response
     */
    'data': Array<GetIssueResponseDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof Issues200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface Issues200ResponseAllOf
 */
export interface Issues200ResponseAllOf {
    /**
     * 
     * @type {Array<GetIssueResponseDto>}
     * @memberof Issues200ResponseAllOf
     */
    'data'?: Array<GetIssueResponseDto>;
}
/**
 * 
 * @export
 * @interface ManagedIssuesDto
 */
export interface ManagedIssuesDto {
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'notInitiated': number;
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'initiated': number;
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'ongoing': number;
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'overdue': number;
    /**
     * 
     * @type {number}
     * @memberof ManagedIssuesDto
     */
    'slaOverdue': number;
}
/**
 * @type ManagerArrayOrSingleString
 * @export
 */
export type ManagerArrayOrSingleString = Array<string> | string;

/**
 * @type ManagersArrayOrSingleString
 * @export
 */
export type ManagersArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface MinimalIssueSubtypeDto
 */
export interface MinimalIssueSubtypeDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalIssueSubtypeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalIssueSubtypeDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MinimalIssueTypeDto
 */
export interface MinimalIssueTypeDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalIssueTypeDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalIssueTypeDto
     */
    'name': MinimalIssueTypeDtoNameEnum;
}

export const MinimalIssueTypeDtoNameEnum = {
    AuditFinding: 'audit-finding',
    ControlDeficiency: 'control-deficiency',
    Issue: 'issue',
    Incident: 'incident',
    Exception: 'exception'
} as const;

export type MinimalIssueTypeDtoNameEnum = typeof MinimalIssueTypeDtoNameEnum[keyof typeof MinimalIssueTypeDtoNameEnum];

/**
 * 
 * @export
 * @interface MinimalUserDto
 */
export interface MinimalUserDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalUserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalUserDto
     */
    'initials': string | null;
}
/**
 * @type NameArrayOrSingleString
 * @export
 */
export type NameArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface OrganizationIdentificationDto
 */
export interface OrganizationIdentificationDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIdentificationDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface OwnedActionsDto
 */
export interface OwnedActionsDto {
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'overdue': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'open': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'inProgress': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'toBeApproved': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedActionsDto
     */
    'completed': number;
}
/**
 * 
 * @export
 * @interface OwnedIssuesDto
 */
export interface OwnedIssuesDto {
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'actionsNotInitiated': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'actionsInitiated': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'overdue': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'actionsOngoing': number;
    /**
     * 
     * @type {number}
     * @memberof OwnedIssuesDto
     */
    'toBeApproved': number;
}
/**
 * @type OwnerArrayOrSingleString
 * @export
 */
export type OwnerArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface PageDto
 */
export interface PageDto {
    /**
     * 
     * @type {object}
     * @memberof PageDto
     */
    'data': object;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof PageDto
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface PageMetaDto
 */
export interface PageMetaDto {
    /**
     * 
     * @type {number}
     * @memberof PageMetaDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageMetaDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof PageMetaDto
     */
    'itemCount': number;
    /**
     * 
     * @type {number}
     * @memberof PageMetaDto
     */
    'pageCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageMetaDto
     */
    'hasPreviousPage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageMetaDto
     */
    'hasNextPage': boolean;
}
/**
 * 
 * @export
 * @interface PageOptionsDto
 */
export interface PageOptionsDto {
    /**
     * 
     * @type {number}
     * @memberof PageOptionsDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageOptionsDto
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface QuickFilterNumbersDto
 */
export interface QuickFilterNumbersDto {
    /**
     * 
     * @type {CreatedIssuesDto}
     * @memberof QuickFilterNumbersDto
     */
    'createdIssues': CreatedIssuesDto;
    /**
     * 
     * @type {IncomingIssuesDto}
     * @memberof QuickFilterNumbersDto
     */
    'incomingIssues': IncomingIssuesDto;
    /**
     * 
     * @type {ManagedIssuesDto}
     * @memberof QuickFilterNumbersDto
     */
    'managedIssues': ManagedIssuesDto;
    /**
     * 
     * @type {OwnedIssuesDto}
     * @memberof QuickFilterNumbersDto
     */
    'ownedIssues': OwnedIssuesDto;
    /**
     * 
     * @type {OwnedActionsDto}
     * @memberof QuickFilterNumbersDto
     */
    'ownedActions': OwnedActionsDto;
    /**
     * 
     * @type {ToBeApprovedDto}
     * @memberof QuickFilterNumbersDto
     */
    'toBeApproved': ToBeApprovedDto;
}
/**
 * 
 * @export
 * @interface SLAFilteringDtoOptions
 */
export interface SLAFilteringDtoOptions {
    /**
     * 
     * @type {IssueTypeArrayOrSingleString}
     * @memberof SLAFilteringDtoOptions
     */
    'issueType'?: IssueTypeArrayOrSingleString;
    /**
     * 
     * @type {IssueSubtypeArrayOrSingleString}
     * @memberof SLAFilteringDtoOptions
     */
    'issueSubtype'?: IssueSubtypeArrayOrSingleString;
    /**
     * 
     * @type {IssueTemplateFilteringDtoOptionsSeverity}
     * @memberof SLAFilteringDtoOptions
     */
    'severity'?: IssueTemplateFilteringDtoOptionsSeverity;
}
/**
 * 
 * @export
 * @interface SLASortingDtoOptions
 */
export interface SLASortingDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'issueType'?: SLASortingDtoOptionsIssueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'issueSubtype'?: SLASortingDtoOptionsIssueSubtypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'severity'?: SLASortingDtoOptionsSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'slaDays'?: SLASortingDtoOptionsSlaDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'maxDueDate'?: SLASortingDtoOptionsMaxDueDateEnum;
    /**
     * 
     * @type {string}
     * @memberof SLASortingDtoOptions
     */
    'escalationDays'?: SLASortingDtoOptionsEscalationDaysEnum;
}

export const SLASortingDtoOptionsIssueTypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsIssueTypeEnum = typeof SLASortingDtoOptionsIssueTypeEnum[keyof typeof SLASortingDtoOptionsIssueTypeEnum];
export const SLASortingDtoOptionsIssueSubtypeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsIssueSubtypeEnum = typeof SLASortingDtoOptionsIssueSubtypeEnum[keyof typeof SLASortingDtoOptionsIssueSubtypeEnum];
export const SLASortingDtoOptionsSeverityEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsSeverityEnum = typeof SLASortingDtoOptionsSeverityEnum[keyof typeof SLASortingDtoOptionsSeverityEnum];
export const SLASortingDtoOptionsSlaDaysEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsSlaDaysEnum = typeof SLASortingDtoOptionsSlaDaysEnum[keyof typeof SLASortingDtoOptionsSlaDaysEnum];
export const SLASortingDtoOptionsMaxDueDateEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsMaxDueDateEnum = typeof SLASortingDtoOptionsMaxDueDateEnum[keyof typeof SLASortingDtoOptionsMaxDueDateEnum];
export const SLASortingDtoOptionsEscalationDaysEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SLASortingDtoOptionsEscalationDaysEnum = typeof SLASortingDtoOptionsEscalationDaysEnum[keyof typeof SLASortingDtoOptionsEscalationDaysEnum];

/**
 * 
 * @export
 * @interface SLAViewDto
 */
export interface SLAViewDto {
    /**
     * 
     * @type {IdNamePropertyDto}
     * @memberof SLAViewDto
     */
    'issueType': IdNamePropertyDto;
    /**
     * 
     * @type {IdNamePropertyDto}
     * @memberof SLAViewDto
     */
    'issueSubtype': IdNamePropertyDto | null;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'issueTypeId': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'issueSubtypeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'severity': SLAViewDtoSeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof SLAViewDto
     */
    'slaDays': number;
    /**
     * 
     * @type {number}
     * @memberof SLAViewDto
     */
    'maxDueDate': number;
    /**
     * 
     * @type {number}
     * @memberof SLAViewDto
     */
    'escalationDays': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SLAViewDto
     */
    'reminderDays': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SLAViewDto
     */
    'deletedAt': string | null;
}

export const SLAViewDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type SLAViewDtoSeverityEnum = typeof SLAViewDtoSeverityEnum[keyof typeof SLAViewDtoSeverityEnum];

/**
 * 
 * @export
 * @interface SaveActionAttachmentDto
 */
export interface SaveActionAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof SaveActionAttachmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveActionAttachmentDto
     */
    'hbDriveId': string;
    /**
     * 
     * @type {number}
     * @memberof SaveActionAttachmentDto
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof SaveActionAttachmentDto
     */
    'name': string;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof SaveActionAttachmentDto
     */
    'addedBy': AuthUserDto;
    /**
     * 
     * @type {Date}
     * @memberof SaveActionAttachmentDto
     */
    'createdAt': Date;
    /**
     * 
     * @type {string}
     * @memberof SaveActionAttachmentDto
     */
    'attachmentType'?: SaveActionAttachmentDtoAttachmentTypeEnum;
}

export const SaveActionAttachmentDtoAttachmentTypeEnum = {
    Attachment: 'attachment',
    Approval: 'approval',
    Declination: 'declination'
} as const;

export type SaveActionAttachmentDtoAttachmentTypeEnum = typeof SaveActionAttachmentDtoAttachmentTypeEnum[keyof typeof SaveActionAttachmentDtoAttachmentTypeEnum];

/**
 * 
 * @export
 * @interface SaveActionRequestDto
 */
export interface SaveActionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'title': string;
    /**
     * 
     * @type {Date}
     * @memberof SaveActionRequestDto
     */
    'dueDate'?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'ownerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'approverId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveActionRequestDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'approvalStatus'?: SaveActionRequestDtoApprovalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'declineNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'slaStatus'?: SaveActionRequestDtoSlaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'slugId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveActionRequestDto
     */
    'status'?: SaveActionRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof SaveActionRequestDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
    /**
     * 
     * @type {number}
     * @memberof SaveActionRequestDto
     */
    'sequence'?: number | null;
}

export const SaveActionRequestDtoApprovalStatusEnum = {
    NotSet: 'not-set',
    WaitingForApproval: 'waiting-for-approval',
    Approved: 'approved',
    Denied: 'denied'
} as const;

export type SaveActionRequestDtoApprovalStatusEnum = typeof SaveActionRequestDtoApprovalStatusEnum[keyof typeof SaveActionRequestDtoApprovalStatusEnum];
export const SaveActionRequestDtoSlaStatusEnum = {
    Sla: 'sla',
    Overdue: 'overdue',
    NoProblem: 'no-problem',
    SlaReached: 'sla-reached'
} as const;

export type SaveActionRequestDtoSlaStatusEnum = typeof SaveActionRequestDtoSlaStatusEnum[keyof typeof SaveActionRequestDtoSlaStatusEnum];
export const SaveActionRequestDtoStatusEnum = {
    Draft: 'action-draft',
    Pending: 'action-pending',
    Open: 'action-open',
    InProgress: 'action-in-progress',
    ToBeApproved: 'action-to-be-approved',
    Completed: 'action-completed',
    Discarded: 'action-discarded'
} as const;

export type SaveActionRequestDtoStatusEnum = typeof SaveActionRequestDtoStatusEnum[keyof typeof SaveActionRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface SaveAttachmentDto
 */
export interface SaveAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof SaveAttachmentDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveAttachmentDto
     */
    'hbDriveId': string;
    /**
     * 
     * @type {number}
     * @memberof SaveAttachmentDto
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof SaveAttachmentDto
     */
    'name': string;
    /**
     * 
     * @type {AuthUserDto}
     * @memberof SaveAttachmentDto
     */
    'addedBy': AuthUserDto;
    /**
     * 
     * @type {Date}
     * @memberof SaveAttachmentDto
     */
    'createdAt': Date;
}
/**
 * 
 * @export
 * @interface SaveIssueRequestDto
 */
export interface SaveIssueRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'severity'?: SaveIssueRequestDtoSeverityEnum;
    /**
     * 
     * @type {Date}
     * @memberof SaveIssueRequestDto
     */
    'dueDate'?: Date;
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'managerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'ownerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'approverId'?: string;
    /**
     * 
     * @type {Array<SaveActionRequestDto>}
     * @memberof SaveIssueRequestDto
     */
    'actions'?: Array<SaveActionRequestDto> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'selectedTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveIssueRequestDto
     */
    'executionType'?: SaveIssueRequestDtoExecutionTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveIssueRequestDto
     */
    'govmapGroups'?: Array<string>;
    /**
     * 
     * @type {Array<SaveAttachmentDto>}
     * @memberof SaveIssueRequestDto
     */
    'attachments'?: Array<SaveAttachmentDto>;
}

export const SaveIssueRequestDtoSeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Critical: 'Critical'
} as const;

export type SaveIssueRequestDtoSeverityEnum = typeof SaveIssueRequestDtoSeverityEnum[keyof typeof SaveIssueRequestDtoSeverityEnum];
export const SaveIssueRequestDtoExecutionTypeEnum = {
    Parallel: 'parallel',
    Sequential: 'sequential'
} as const;

export type SaveIssueRequestDtoExecutionTypeEnum = typeof SaveIssueRequestDtoExecutionTypeEnum[keyof typeof SaveIssueRequestDtoExecutionTypeEnum];

/**
 * 
 * @export
 * @interface SeverityStatisticsDto
 */
export interface SeverityStatisticsDto {
    /**
     * 
     * @type {number}
     * @memberof SeverityStatisticsDto
     */
    'low'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityStatisticsDto
     */
    'medium'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityStatisticsDto
     */
    'high'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityStatisticsDto
     */
    'critical'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityStatisticsDto
     */
    'notDefined'?: number;
}
/**
 * @type SlaDueDaysArrayOrSingleString
 * @export
 */
export type SlaDueDaysArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface Slas200Response
 */
export interface Slas200Response {
    /**
     * 
     * @type {Array<SLAViewDto>}
     * @memberof Slas200Response
     */
    'data': Array<SLAViewDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof Slas200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface Slas200ResponseAllOf
 */
export interface Slas200ResponseAllOf {
    /**
     * 
     * @type {Array<SLAViewDto>}
     * @memberof Slas200ResponseAllOf
     */
    'data'?: Array<SLAViewDto>;
}
/**
 * 
 * @export
 * @interface StatusStatisticsDto
 */
export interface StatusStatisticsDto {
    /**
     * 
     * @type {number}
     * @memberof StatusStatisticsDto
     */
    'closed'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusStatisticsDto
     */
    'open'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusStatisticsDto
     */
    'discarded'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusStatisticsDto
     */
    'inProgress'?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusStatisticsDto
     */
    'toBeApproved'?: number;
}
/**
 * @type TitleArrayOrSingleString
 * @export
 */
export type TitleArrayOrSingleString = Array<string> | string;

/**
 * 
 * @export
 * @interface ToBeApprovedDto
 */
export interface ToBeApprovedDto {
    /**
     * 
     * @type {number}
     * @memberof ToBeApprovedDto
     */
    'issuesToApprove': number;
    /**
     * 
     * @type {number}
     * @memberof ToBeApprovedDto
     */
    'actionsToApprove': number;
}
/**
 * 
 * @export
 * @interface UpdateIssueSubtypeRequestDto
 */
export interface UpdateIssueSubtypeRequestDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UpdateIssueSubtypeRequestDto
     */
    'issueTypeManagers'?: Array<UserDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateIssueSubtypeRequestDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UpdateIssueTypeRequestDto
 */
export interface UpdateIssueTypeRequestDto {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UpdateIssueTypeRequestDto
     */
    'issueTypeManagers'?: Array<UserDto>;
}
/**
 * 
 * @export
 * @interface UpdateSLARequestDto
 */
export interface UpdateSLARequestDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateSLARequestDto
     */
    'slaDays': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSLARequestDto
     */
    'maxDueDate': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSLARequestDto
     */
    'escalationDays': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateSLARequestDto
     */
    'reminderDays'?: Array<number>;
}
/**
 * 
 * @export
 * @interface UpdateSLAStatusRequestDto
 */
export interface UpdateSLAStatusRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSLAStatusRequestDto
     */
    'state': UpdateSLAStatusRequestDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSLAStatusRequestDto
     */
    'reason': string;
}

export const UpdateSLAStatusRequestDtoStateEnum = {
    Deactivated: 'deactivated',
    Activated: 'activated'
} as const;

export type UpdateSLAStatusRequestDtoStateEnum = typeof UpdateSLAStatusRequestDtoStateEnum[keyof typeof UpdateSLAStatusRequestDtoStateEnum];

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'highbondId': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface UserFilteringDtoOptions
 */
export interface UserFilteringDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof UserFilteringDtoOptions
     */
    'queryMode'?: UserFilteringDtoOptionsQueryModeEnum;
    /**
     * 
     * @type {NameArrayOrSingleString}
     * @memberof UserFilteringDtoOptions
     */
    'name'?: NameArrayOrSingleString;
    /**
     * 
     * @type {EmailArrayOrSingleString}
     * @memberof UserFilteringDtoOptions
     */
    'email'?: EmailArrayOrSingleString;
    /**
     * 
     * @type {IdArrayOrSingleString}
     * @memberof UserFilteringDtoOptions
     */
    'id'?: IdArrayOrSingleString;
    /**
     * 
     * @type {IssueTypeArrayOrSingleString}
     * @memberof UserFilteringDtoOptions
     */
    'issueType'?: IssueTypeArrayOrSingleString;
    /**
     * 
     * @type {IssueSubtypeArrayOrSingleString}
     * @memberof UserFilteringDtoOptions
     */
    'issueSubtype'?: IssueSubtypeArrayOrSingleString;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilteringDtoOptions
     */
    'isIssueOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilteringDtoOptions
     */
    'isActionOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilteringDtoOptions
     */
    'isIssueApprover'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilteringDtoOptions
     */
    'isActionApprover'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserFilteringDtoOptions
     */
    'searchTerm'?: string;
}

export const UserFilteringDtoOptionsQueryModeEnum = {
    AllUsers: 'all-users',
    OnlyIssueTypeManagers: 'only-issue-type-managers'
} as const;

export type UserFilteringDtoOptionsQueryModeEnum = typeof UserFilteringDtoOptionsQueryModeEnum[keyof typeof UserFilteringDtoOptionsQueryModeEnum];

/**
 * 
 * @export
 * @interface UserSortingDtoOptions
 */
export interface UserSortingDtoOptions {
    /**
     * 
     * @type {string}
     * @memberof UserSortingDtoOptions
     */
    'name'?: UserSortingDtoOptionsNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSortingDtoOptions
     */
    'email'?: UserSortingDtoOptionsEmailEnum;
}

export const UserSortingDtoOptionsNameEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type UserSortingDtoOptionsNameEnum = typeof UserSortingDtoOptionsNameEnum[keyof typeof UserSortingDtoOptionsNameEnum];
export const UserSortingDtoOptionsEmailEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type UserSortingDtoOptionsEmailEnum = typeof UserSortingDtoOptionsEmailEnum[keyof typeof UserSortingDtoOptionsEmailEnum];

/**
 * 
 * @export
 * @interface Users200Response
 */
export interface Users200Response {
    /**
     * 
     * @type {Array<AuthUserDto>}
     * @memberof Users200Response
     */
    'data': Array<AuthUserDto>;
    /**
     * 
     * @type {PageMetaDto}
     * @memberof Users200Response
     */
    'meta': PageMetaDto;
}
/**
 * 
 * @export
 * @interface Users200ResponseAllOf
 */
export interface Users200ResponseAllOf {
    /**
     * 
     * @type {Array<AuthUserDto>}
     * @memberof Users200ResponseAllOf
     */
    'data'?: Array<AuthUserDto>;
}

/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
export const AttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAttachment', 'id', id)
            const localVarPath = `/attachments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment: async (attachmentId: string, attachmentName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentId', attachmentId)
            // verify required parameter 'attachmentName' is not null or undefined
            assertParamExists('downloadAttachment', 'attachmentName', attachmentName)
            const localVarPath = `/attachments/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (attachmentId !== undefined) {
                localVarQueryParameter['attachmentId'] = attachmentId;
            }

            if (attachmentName !== undefined) {
                localVarQueryParameter['attachmentName'] = attachmentName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachmentUrl: async (attachmentId: string, attachmentName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('uploadAttachmentUrl', 'attachmentId', attachmentId)
            // verify required parameter 'attachmentName' is not null or undefined
            assertParamExists('uploadAttachmentUrl', 'attachmentName', attachmentName)
            const localVarPath = `/attachments/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (attachmentId !== undefined) {
                localVarQueryParameter['attachmentId'] = attachmentId;
            }

            if (attachmentName !== undefined) {
                localVarQueryParameter['attachmentName'] = attachmentName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAttachment(attachmentId: string, attachmentName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAttachment(attachmentId, attachmentName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachmentUrl(attachmentId: string, attachmentName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachmentUrl(attachmentId, attachmentName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(id: string, options?: any): AxiosPromise<IssueResponseDto> {
            return localVarFp.deleteAttachment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAttachment(attachmentId: string, attachmentName: string, options?: any): AxiosPromise<AttachmentDto> {
            return localVarFp.downloadAttachment(attachmentId, attachmentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} attachmentId 
         * @param {string} attachmentName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachmentUrl(attachmentId: string, attachmentName: string, options?: any): AxiosPromise<AttachmentDto> {
            return localVarFp.uploadAttachmentUrl(attachmentId, attachmentName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public deleteAttachment(id: string, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).deleteAttachment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} attachmentId 
     * @param {string} attachmentName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public downloadAttachment(attachmentId: string, attachmentName: string, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).downloadAttachment(attachmentId, attachmentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} attachmentId 
     * @param {string} attachmentName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public uploadAttachmentUrl(attachmentId: string, attachmentName: string, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).uploadAttachmentUrl(attachmentId, attachmentName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EntityNamesApi - axios parameter creator
 * @export
 */
export const EntityNamesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {EntityNamesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNames: async (filter?: EntityNamesFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityNamesApi - functional programming interface
 * @export
 */
export const EntityNamesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityNamesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {EntityNamesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityNames(filter?: EntityNamesFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEntityNames200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityNames(filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityNamesApi - factory interface
 * @export
 */
export const EntityNamesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityNamesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {EntityNamesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityNames(filter?: EntityNamesFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<GetEntityNames200Response> {
            return localVarFp.getEntityNames(filter, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityNamesApi - object-oriented interface
 * @export
 * @class EntityNamesApi
 * @extends {BaseAPI}
 */
export class EntityNamesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {EntityNamesFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityNamesApi
     */
    public getEntityNames(filter?: EntityNamesFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EntityNamesApiFp(this.configuration).getEntityNames(filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EntityTitlesApi - axios parameter creator
 * @export
 */
export const EntityTitlesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {EntityTitlesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTitles: async (filter?: EntityTitlesFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity-titles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityTitlesApi - functional programming interface
 * @export
 */
export const EntityTitlesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityTitlesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {EntityTitlesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTitles(filter?: EntityTitlesFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEntityTitles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTitles(filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityTitlesApi - factory interface
 * @export
 */
export const EntityTitlesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityTitlesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {EntityTitlesFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTitles(filter?: EntityTitlesFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<GetEntityTitles200Response> {
            return localVarFp.getEntityTitles(filter, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityTitlesApi - object-oriented interface
 * @export
 * @class EntityTitlesApi
 * @extends {BaseAPI}
 */
export class EntityTitlesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {EntityTitlesFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTitlesApi
     */
    public getEntityTitles(filter?: EntityTitlesFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return EntityTitlesApiFp(this.configuration).getEntityTitles(filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FlattenedIssueTypesApi - axios parameter creator
 * @export
 */
export const FlattenedIssueTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {FlattenedIssueTypeSortingDtoOptions} [sort] 
         * @param {FlattenedIssueTypeFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flattenedIssueTypes: async (sort?: FlattenedIssueTypeSortingDtoOptions, filter?: FlattenedIssueTypeFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/flattened-issue-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlattenedIssueTypesApi - functional programming interface
 * @export
 */
export const FlattenedIssueTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlattenedIssueTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {FlattenedIssueTypeSortingDtoOptions} [sort] 
         * @param {FlattenedIssueTypeFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flattenedIssueTypes(sort?: FlattenedIssueTypeSortingDtoOptions, filter?: FlattenedIssueTypeFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlattenedIssueTypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flattenedIssueTypes(sort, filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FlattenedIssueTypesApi - factory interface
 * @export
 */
export const FlattenedIssueTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlattenedIssueTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {FlattenedIssueTypeSortingDtoOptions} [sort] 
         * @param {FlattenedIssueTypeFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flattenedIssueTypes(sort?: FlattenedIssueTypeSortingDtoOptions, filter?: FlattenedIssueTypeFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<FlattenedIssueTypes200Response> {
            return localVarFp.flattenedIssueTypes(sort, filter, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlattenedIssueTypesApi - object-oriented interface
 * @export
 * @class FlattenedIssueTypesApi
 * @extends {BaseAPI}
 */
export class FlattenedIssueTypesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {FlattenedIssueTypeSortingDtoOptions} [sort] 
     * @param {FlattenedIssueTypeFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlattenedIssueTypesApi
     */
    public flattenedIssueTypes(sort?: FlattenedIssueTypeSortingDtoOptions, filter?: FlattenedIssueTypeFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return FlattenedIssueTypesApiFp(this.configuration).flattenedIssueTypes(sort, filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GovmapGroupsApi - axios parameter creator
 * @export
 */
export const GovmapGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {GovmapGroupSortingDtoOptions} [sort] 
         * @param {GovmapGroupFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGovMapGroups: async (sort?: GovmapGroupSortingDtoOptions, filter?: GovmapGroupFilteringDtoOptions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/govmap-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GovmapGroupsApi - functional programming interface
 * @export
 */
export const GovmapGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GovmapGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {GovmapGroupSortingDtoOptions} [sort] 
         * @param {GovmapGroupFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGovMapGroups(sort?: GovmapGroupSortingDtoOptions, filter?: GovmapGroupFilteringDtoOptions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetGovMapGroupsResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGovMapGroups(sort, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GovmapGroupsApi - factory interface
 * @export
 */
export const GovmapGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GovmapGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {GovmapGroupSortingDtoOptions} [sort] 
         * @param {GovmapGroupFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGovMapGroups(sort?: GovmapGroupSortingDtoOptions, filter?: GovmapGroupFilteringDtoOptions, options?: any): AxiosPromise<Array<GetGovMapGroupsResponseDto>> {
            return localVarFp.getGovMapGroups(sort, filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GovmapGroupsApi - object-oriented interface
 * @export
 * @class GovmapGroupsApi
 * @extends {BaseAPI}
 */
export class GovmapGroupsApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {GovmapGroupSortingDtoOptions} [sort] 
     * @param {GovmapGroupFilteringDtoOptions} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GovmapGroupsApi
     */
    public getGovMapGroups(sort?: GovmapGroupSortingDtoOptions, filter?: GovmapGroupFilteringDtoOptions, options?: AxiosRequestConfig) {
        return GovmapGroupsApiFp(this.configuration).getGovMapGroups(sort, filter, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssueActionCountApi - axios parameter creator
 * @export
 */
export const IssueActionCountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {IssueActionCountFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueActionCount: async (filter?: IssueActionCountFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issue-action-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssueActionCountApi - functional programming interface
 * @export
 */
export const IssueActionCountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssueActionCountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {IssueActionCountFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssueActionCount(filter?: IssueActionCountFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueActionCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssueActionCount(filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssueActionCountApi - factory interface
 * @export
 */
export const IssueActionCountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssueActionCountApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {IssueActionCountFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueActionCount(filter?: IssueActionCountFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<GetIssueActionCount200Response> {
            return localVarFp.getIssueActionCount(filter, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssueActionCountApi - object-oriented interface
 * @export
 * @class IssueActionCountApi
 * @extends {BaseAPI}
 */
export class IssueActionCountApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {IssueActionCountFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueActionCountApi
     */
    public getIssueActionCount(filter?: IssueActionCountFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return IssueActionCountApiFp(this.configuration).getIssueActionCount(filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssueSlasApi - axios parameter creator
 * @export
 */
export const IssueSlasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {IssueSLAsFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueSLAs: async (filter?: IssueSLAsFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issue-slas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssueSlasApi - functional programming interface
 * @export
 */
export const IssueSlasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssueSlasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {IssueSLAsFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssueSLAs(filter?: IssueSLAsFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueSLAs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssueSLAs(filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssueSlasApi - factory interface
 * @export
 */
export const IssueSlasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssueSlasApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {IssueSLAsFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueSLAs(filter?: IssueSLAsFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<GetIssueSLAs200Response> {
            return localVarFp.getIssueSLAs(filter, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssueSlasApi - object-oriented interface
 * @export
 * @class IssueSlasApi
 * @extends {BaseAPI}
 */
export class IssueSlasApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {IssueSLAsFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSlasApi
     */
    public getIssueSLAs(filter?: IssueSLAsFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return IssueSlasApiFp(this.configuration).getIssueSLAs(filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssueSubtypesApi - axios parameter creator
 * @export
 */
export const IssueSubtypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreateIssueSubtypeRequestDto} createIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueSubtype: async (createIssueSubtypeRequestDto: CreateIssueSubtypeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIssueSubtypeRequestDto' is not null or undefined
            assertParamExists('createIssueSubtype', 'createIssueSubtypeRequestDto', createIssueSubtypeRequestDto)
            const localVarPath = `/issue-subtypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIssueSubtypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIssueSubtype: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteIssueSubtype', 'id', id)
            const localVarPath = `/issue-subtypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSubtype: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('issueSubtype', 'id', id)
            const localVarPath = `/issue-subtypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueManager] 
         * @param {Array<string>} [filterByIssueTypes] 
         * @param {string} [filterByIssueType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSubtypes: async (page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueManager?: boolean, filterByIssueTypes?: Array<string>, filterByIssueType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issue-subtypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderByName !== undefined) {
                localVarQueryParameter['orderByName'] = orderByName;
            }

            if (filterById !== undefined) {
                localVarQueryParameter['filterById'] = filterById;
            }

            if (filterByName !== undefined) {
                localVarQueryParameter['filterByName'] = filterByName;
            }

            if (filterByEnabled !== undefined) {
                localVarQueryParameter['filterByEnabled'] = filterByEnabled;
            }

            if (filterByIssueManager !== undefined) {
                localVarQueryParameter['filterByIssueManager'] = filterByIssueManager;
            }

            if (filterByIssueTypes) {
                localVarQueryParameter['filterByIssueTypes'] = filterByIssueTypes;
            }

            if (filterByIssueType !== undefined) {
                localVarQueryParameter['filterByIssueType'] = filterByIssueType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueSubtypeRequestDto} updateIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueSubtype: async (id: string, updateIssueSubtypeRequestDto: UpdateIssueSubtypeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIssueSubtype', 'id', id)
            // verify required parameter 'updateIssueSubtypeRequestDto' is not null or undefined
            assertParamExists('updateIssueSubtype', 'updateIssueSubtypeRequestDto', updateIssueSubtypeRequestDto)
            const localVarPath = `/issue-subtypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIssueSubtypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssueSubtypesApi - functional programming interface
 * @export
 */
export const IssueSubtypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssueSubtypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateIssueSubtypeRequestDto} createIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssueSubtype(createIssueSubtypeRequestDto: CreateIssueSubtypeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueSubtypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssueSubtype(createIssueSubtypeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIssueSubtype(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIssueSubtype(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueSubtype(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueSubtypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueSubtype(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueManager] 
         * @param {Array<string>} [filterByIssueTypes] 
         * @param {string} [filterByIssueType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueSubtypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueManager?: boolean, filterByIssueTypes?: Array<string>, filterByIssueType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueSubtypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueSubtypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueManager, filterByIssueTypes, filterByIssueType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueSubtypeRequestDto} updateIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIssueSubtype(id: string, updateIssueSubtypeRequestDto: UpdateIssueSubtypeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueSubtypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIssueSubtype(id, updateIssueSubtypeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssueSubtypesApi - factory interface
 * @export
 */
export const IssueSubtypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssueSubtypesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateIssueSubtypeRequestDto} createIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueSubtype(createIssueSubtypeRequestDto: CreateIssueSubtypeRequestDto, options?: any): AxiosPromise<IssueSubtypeDto> {
            return localVarFp.createIssueSubtype(createIssueSubtypeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIssueSubtype(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteIssueSubtype(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSubtype(id: string, options?: any): AxiosPromise<IssueSubtypeDto> {
            return localVarFp.issueSubtype(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueManager] 
         * @param {Array<string>} [filterByIssueTypes] 
         * @param {string} [filterByIssueType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSubtypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueManager?: boolean, filterByIssueTypes?: Array<string>, filterByIssueType?: string, options?: any): AxiosPromise<IssueSubtypes200Response> {
            return localVarFp.issueSubtypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueManager, filterByIssueTypes, filterByIssueType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueSubtypeRequestDto} updateIssueSubtypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueSubtype(id: string, updateIssueSubtypeRequestDto: UpdateIssueSubtypeRequestDto, options?: any): AxiosPromise<IssueSubtypeDto> {
            return localVarFp.updateIssueSubtype(id, updateIssueSubtypeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssueSubtypesApi - object-oriented interface
 * @export
 * @class IssueSubtypesApi
 * @extends {BaseAPI}
 */
export class IssueSubtypesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreateIssueSubtypeRequestDto} createIssueSubtypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSubtypesApi
     */
    public createIssueSubtype(createIssueSubtypeRequestDto: CreateIssueSubtypeRequestDto, options?: AxiosRequestConfig) {
        return IssueSubtypesApiFp(this.configuration).createIssueSubtype(createIssueSubtypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSubtypesApi
     */
    public deleteIssueSubtype(id: string, options?: AxiosRequestConfig) {
        return IssueSubtypesApiFp(this.configuration).deleteIssueSubtype(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSubtypesApi
     */
    public issueSubtype(id: string, options?: AxiosRequestConfig) {
        return IssueSubtypesApiFp(this.configuration).issueSubtype(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {'asc' | 'desc'} [orderByName] 
     * @param {string} [filterById] 
     * @param {string} [filterByName] 
     * @param {boolean} [filterByEnabled] 
     * @param {boolean} [filterByIssueManager] 
     * @param {Array<string>} [filterByIssueTypes] 
     * @param {string} [filterByIssueType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSubtypesApi
     */
    public issueSubtypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueManager?: boolean, filterByIssueTypes?: Array<string>, filterByIssueType?: string, options?: AxiosRequestConfig) {
        return IssueSubtypesApiFp(this.configuration).issueSubtypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueManager, filterByIssueTypes, filterByIssueType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateIssueSubtypeRequestDto} updateIssueSubtypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueSubtypesApi
     */
    public updateIssueSubtype(id: string, updateIssueSubtypeRequestDto: UpdateIssueSubtypeRequestDto, options?: AxiosRequestConfig) {
        return IssueSubtypesApiFp(this.configuration).updateIssueSubtype(id, updateIssueSubtypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssueTemplatesApi - axios parameter creator
 * @export
 */
export const IssueTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an issue template to a given issue type
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueTemplate: async (createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIssueTemplateRequestDto' is not null or undefined
            assertParamExists('createIssueTemplate', 'createIssueTemplateRequestDto', createIssueTemplateRequestDto)
            const localVarPath = `/issue-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIssueTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIssueTypeAndSubtype: async (issueTypeId: string, issueSubtypeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issueTypeId' is not null or undefined
            assertParamExists('findByIssueTypeAndSubtype', 'issueTypeId', issueTypeId)
            const localVarPath = `/issue-templates/find-by-issue-type-and-subtype`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (issueTypeId !== undefined) {
                localVarQueryParameter['issueTypeId'] = issueTypeId;
            }

            if (issueSubtypeId !== undefined) {
                localVarQueryParameter['issueSubtypeId'] = issueSubtypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an issue template by slug, issueTypeId and issueSubtypeId
         * @param {string} slug 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueTemplate: async (slug: string, issueTypeId: string, issueSubtypeId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getIssueTemplate', 'slug', slug)
            // verify required parameter 'issueTypeId' is not null or undefined
            assertParamExists('getIssueTemplate', 'issueTypeId', issueTypeId)
            const localVarPath = `/issue-templates/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (issueTypeId !== undefined) {
                localVarQueryParameter['issueTypeId'] = issueTypeId;
            }

            if (issueSubtypeId !== undefined) {
                localVarQueryParameter['issueSubtypeId'] = issueSubtypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {IssueTemplateSortingDtoOptions} [sort] 
         * @param {IssueTemplateFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTemplates: async (sort?: IssueTemplateSortingDtoOptions, filter?: IssueTemplateFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issue-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes details of a given issue template
         * @param {string} slug 
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueTemplate: async (slug: string, createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('updateIssueTemplate', 'slug', slug)
            // verify required parameter 'createIssueTemplateRequestDto' is not null or undefined
            assertParamExists('updateIssueTemplate', 'createIssueTemplateRequestDto', createIssueTemplateRequestDto)
            const localVarPath = `/issue-templates/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIssueTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssueTemplatesApi - functional programming interface
 * @export
 */
export const IssueTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssueTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an issue template to a given issue type
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssueTemplate(createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTemplateCreatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssueTemplate(createIssueTemplateRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByIssueTypeAndSubtype(issueTypeId: string, issueSubtypeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueTemplateByIssueTypeIssueSubtypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByIssueTypeAndSubtype(issueTypeId, issueSubtypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an issue template by slug, issueTypeId and issueSubtypeId
         * @param {string} slug 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssueTemplate(slug: string, issueTypeId: string, issueSubtypeId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssueTemplate(slug, issueTypeId, issueSubtypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {IssueTemplateSortingDtoOptions} [sort] 
         * @param {IssueTemplateFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueTemplates(sort?: IssueTemplateSortingDtoOptions, filter?: IssueTemplateFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTemplates200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueTemplates(sort, filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes details of a given issue template
         * @param {string} slug 
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIssueTemplate(slug: string, createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTemplateUpdatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIssueTemplate(slug, createIssueTemplateRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssueTemplatesApi - factory interface
 * @export
 */
export const IssueTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssueTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an issue template to a given issue type
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueTemplate(createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: any): AxiosPromise<IssueTemplateCreatedResponseDto> {
            return localVarFp.createIssueTemplate(createIssueTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIssueTypeAndSubtype(issueTypeId: string, issueSubtypeId?: string, options?: any): AxiosPromise<GetIssueTemplateByIssueTypeIssueSubtypeResponseDto> {
            return localVarFp.findByIssueTypeAndSubtype(issueTypeId, issueSubtypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an issue template by slug, issueTypeId and issueSubtypeId
         * @param {string} slug 
         * @param {string} issueTypeId 
         * @param {string} [issueSubtypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueTemplate(slug: string, issueTypeId: string, issueSubtypeId?: string, options?: any): AxiosPromise<IssueTemplateDto> {
            return localVarFp.getIssueTemplate(slug, issueTypeId, issueSubtypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {IssueTemplateSortingDtoOptions} [sort] 
         * @param {IssueTemplateFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTemplates(sort?: IssueTemplateSortingDtoOptions, filter?: IssueTemplateFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<IssueTemplates200Response> {
            return localVarFp.issueTemplates(sort, filter, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes details of a given issue template
         * @param {string} slug 
         * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueTemplate(slug: string, createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: any): AxiosPromise<IssueTemplateUpdatedResponseDto> {
            return localVarFp.updateIssueTemplate(slug, createIssueTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssueTemplatesApi - object-oriented interface
 * @export
 * @class IssueTemplatesApi
 * @extends {BaseAPI}
 */
export class IssueTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Add an issue template to a given issue type
     * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTemplatesApi
     */
    public createIssueTemplate(createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: AxiosRequestConfig) {
        return IssueTemplatesApiFp(this.configuration).createIssueTemplate(createIssueTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issueTypeId 
     * @param {string} [issueSubtypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTemplatesApi
     */
    public findByIssueTypeAndSubtype(issueTypeId: string, issueSubtypeId?: string, options?: AxiosRequestConfig) {
        return IssueTemplatesApiFp(this.configuration).findByIssueTypeAndSubtype(issueTypeId, issueSubtypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an issue template by slug, issueTypeId and issueSubtypeId
     * @param {string} slug 
     * @param {string} issueTypeId 
     * @param {string} [issueSubtypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTemplatesApi
     */
    public getIssueTemplate(slug: string, issueTypeId: string, issueSubtypeId?: string, options?: AxiosRequestConfig) {
        return IssueTemplatesApiFp(this.configuration).getIssueTemplate(slug, issueTypeId, issueSubtypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {IssueTemplateSortingDtoOptions} [sort] 
     * @param {IssueTemplateFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTemplatesApi
     */
    public issueTemplates(sort?: IssueTemplateSortingDtoOptions, filter?: IssueTemplateFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return IssueTemplatesApiFp(this.configuration).issueTemplates(sort, filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes details of a given issue template
     * @param {string} slug 
     * @param {CreateIssueTemplateRequestDto} createIssueTemplateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTemplatesApi
     */
    public updateIssueTemplate(slug: string, createIssueTemplateRequestDto: CreateIssueTemplateRequestDto, options?: AxiosRequestConfig) {
        return IssueTemplatesApiFp(this.configuration).updateIssueTemplate(slug, createIssueTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssueTypesApi - axios parameter creator
 * @export
 */
export const IssueTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueType: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('issueType', 'id', id)
            const localVarPath = `/issue-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueTypeManager] 
         * @param {boolean} [populateIssueTypeManagers] 
         * @param {boolean} [populateIssueSubtypes] 
         * @param {boolean} [populateIssueSubtypeIssueTypeManagers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTypes: async (page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueTypeManager?: boolean, populateIssueTypeManagers?: boolean, populateIssueSubtypes?: boolean, populateIssueSubtypeIssueTypeManagers?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issue-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderByName !== undefined) {
                localVarQueryParameter['orderByName'] = orderByName;
            }

            if (filterById !== undefined) {
                localVarQueryParameter['filterById'] = filterById;
            }

            if (filterByName !== undefined) {
                localVarQueryParameter['filterByName'] = filterByName;
            }

            if (filterByEnabled !== undefined) {
                localVarQueryParameter['filterByEnabled'] = filterByEnabled;
            }

            if (filterByIssueTypeManager !== undefined) {
                localVarQueryParameter['filterByIssueTypeManager'] = filterByIssueTypeManager;
            }

            if (populateIssueTypeManagers !== undefined) {
                localVarQueryParameter['populateIssueTypeManagers'] = populateIssueTypeManagers;
            }

            if (populateIssueSubtypes !== undefined) {
                localVarQueryParameter['populateIssueSubtypes'] = populateIssueSubtypes;
            }

            if (populateIssueSubtypeIssueTypeManagers !== undefined) {
                localVarQueryParameter['populateIssueSubtypeIssueTypeManagers'] = populateIssueSubtypeIssueTypeManagers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueTypeRequestDto} updateIssueTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueType: async (id: string, updateIssueTypeRequestDto: UpdateIssueTypeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateIssueType', 'id', id)
            // verify required parameter 'updateIssueTypeRequestDto' is not null or undefined
            assertParamExists('updateIssueType', 'updateIssueTypeRequestDto', updateIssueTypeRequestDto)
            const localVarPath = `/issue-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIssueTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssueTypesApi - functional programming interface
 * @export
 */
export const IssueTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssueTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueType(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueTypeManager] 
         * @param {boolean} [populateIssueTypeManagers] 
         * @param {boolean} [populateIssueSubtypes] 
         * @param {boolean} [populateIssueSubtypeIssueTypeManagers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueTypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueTypeManager?: boolean, populateIssueTypeManagers?: boolean, populateIssueSubtypes?: boolean, populateIssueSubtypeIssueTypeManagers?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueTypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueTypeManager, populateIssueTypeManagers, populateIssueSubtypes, populateIssueSubtypeIssueTypeManagers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueTypeRequestDto} updateIssueTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIssueType(id: string, updateIssueTypeRequestDto: UpdateIssueTypeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIssueType(id, updateIssueTypeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssueTypesApi - factory interface
 * @export
 */
export const IssueTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssueTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueType(id: string, options?: any): AxiosPromise<IssueTypeDto> {
            return localVarFp.issueType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {'asc' | 'desc'} [orderByName] 
         * @param {string} [filterById] 
         * @param {string} [filterByName] 
         * @param {boolean} [filterByEnabled] 
         * @param {boolean} [filterByIssueTypeManager] 
         * @param {boolean} [populateIssueTypeManagers] 
         * @param {boolean} [populateIssueSubtypes] 
         * @param {boolean} [populateIssueSubtypeIssueTypeManagers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueTypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueTypeManager?: boolean, populateIssueTypeManagers?: boolean, populateIssueSubtypes?: boolean, populateIssueSubtypeIssueTypeManagers?: boolean, options?: any): AxiosPromise<IssueTypes200Response> {
            return localVarFp.issueTypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueTypeManager, populateIssueTypeManagers, populateIssueSubtypes, populateIssueSubtypeIssueTypeManagers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateIssueTypeRequestDto} updateIssueTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssueType(id: string, updateIssueTypeRequestDto: UpdateIssueTypeRequestDto, options?: any): AxiosPromise<IssueTypeDto> {
            return localVarFp.updateIssueType(id, updateIssueTypeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssueTypesApi - object-oriented interface
 * @export
 * @class IssueTypesApi
 * @extends {BaseAPI}
 */
export class IssueTypesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTypesApi
     */
    public issueType(id: string, options?: AxiosRequestConfig) {
        return IssueTypesApiFp(this.configuration).issueType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {'asc' | 'desc'} [orderByName] 
     * @param {string} [filterById] 
     * @param {string} [filterByName] 
     * @param {boolean} [filterByEnabled] 
     * @param {boolean} [filterByIssueTypeManager] 
     * @param {boolean} [populateIssueTypeManagers] 
     * @param {boolean} [populateIssueSubtypes] 
     * @param {boolean} [populateIssueSubtypeIssueTypeManagers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTypesApi
     */
    public issueTypes(page?: number, limit?: number, orderByName?: 'asc' | 'desc', filterById?: string, filterByName?: string, filterByEnabled?: boolean, filterByIssueTypeManager?: boolean, populateIssueTypeManagers?: boolean, populateIssueSubtypes?: boolean, populateIssueSubtypeIssueTypeManagers?: boolean, options?: AxiosRequestConfig) {
        return IssueTypesApiFp(this.configuration).issueTypes(page, limit, orderByName, filterById, filterByName, filterByEnabled, filterByIssueTypeManager, populateIssueTypeManagers, populateIssueSubtypes, populateIssueSubtypeIssueTypeManagers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateIssueTypeRequestDto} updateIssueTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssueTypesApi
     */
    public updateIssueType(id: string, updateIssueTypeRequestDto: UpdateIssueTypeRequestDto, options?: AxiosRequestConfig) {
        return IssueTypesApiFp(this.configuration).updateIssueType(id, updateIssueTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssuesApi - axios parameter creator
 * @export
 */
export const IssuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {ApproveActionDto} approveActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAction: async (code: string, id: string, approveActionDto: ApproveActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('approveAction', 'code', code)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveAction', 'id', id)
            // verify required parameter 'approveActionDto' is not null or undefined
            assertParamExists('approveAction', 'approveActionDto', approveActionDto)
            const localVarPath = `/issues/{code}/actions/{id}/approve`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {ApproveIssueRequestDto} approveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveIssue: async (code: string, approveIssueRequestDto: ApproveIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('approveIssue', 'code', code)
            // verify required parameter 'approveIssueRequestDto' is not null or undefined
            assertParamExists('approveIssue', 'approveIssueRequestDto', approveIssueRequestDto)
            const localVarPath = `/issues/{code}/approve`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AssignIssueRequestDto} assignIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignIssue: async (code: string, assignIssueRequestDto: AssignIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('assignIssue', 'code', code)
            // verify required parameter 'assignIssueRequestDto' is not null or undefined
            assertParamExists('assignIssue', 'assignIssueRequestDto', assignIssueRequestDto)
            const localVarPath = `/issues/{code}/assign`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {CreateIssueRequestDto} createIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue: async (createIssueRequestDto: CreateIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIssueRequestDto' is not null or undefined
            assertParamExists('createIssue', 'createIssueRequestDto', createIssueRequestDto)
            const localVarPath = `/issues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AddCommentRequestDto} addCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueComment: async (code: string, addCommentRequestDto: AddCommentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('createIssueComment', 'code', code)
            // verify required parameter 'addCommentRequestDto' is not null or undefined
            assertParamExists('createIssueComment', 'addCommentRequestDto', addCommentRequestDto)
            const localVarPath = `/issues/{code}/comments`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {DeclineActionRequestDto} declineActionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineAction: async (code: string, id: string, declineActionRequestDto: DeclineActionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('declineAction', 'code', code)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineAction', 'id', id)
            // verify required parameter 'declineActionRequestDto' is not null or undefined
            assertParamExists('declineAction', 'declineActionRequestDto', declineActionRequestDto)
            const localVarPath = `/issues/{code}/actions/{id}/decline`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineActionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DeclineIssueRequestDto} declineIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineIssue: async (code: string, declineIssueRequestDto: DeclineIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('declineIssue', 'code', code)
            // verify required parameter 'declineIssueRequestDto' is not null or undefined
            assertParamExists('declineIssue', 'declineIssueRequestDto', declineIssueRequestDto)
            const localVarPath = `/issues/{code}/decline`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DiscardIssueRequestDto} discardIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardIssue: async (code: string, discardIssueRequestDto: DiscardIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('discardIssue', 'code', code)
            // verify required parameter 'discardIssueRequestDto' is not null or undefined
            assertParamExists('discardIssue', 'discardIssueRequestDto', discardIssueRequestDto)
            const localVarPath = `/issues/{code}/discard`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discardIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {FinishActionDto} finishActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishAction: async (code: string, id: string, finishActionDto: FinishActionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('finishAction', 'code', code)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finishAction', 'id', id)
            // verify required parameter 'finishActionDto' is not null or undefined
            assertParamExists('finishAction', 'finishActionDto', finishActionDto)
            const localVarPath = `/issues/{code}/actions/{id}/finish`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finishActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getIssue', 'code', code)
            const localVarPath = `/issues/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickFilterStatistics: async (sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issues/quick-filter-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issues/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getUserRoles', 'code', code)
            const localVarPath = `/issues/{code}/user-roles`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {InitiateWorkflowDto} initiateWorkflowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateWorkflow: async (code: string, initiateWorkflowDto: InitiateWorkflowDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('initiateWorkflow', 'code', code)
            // verify required parameter 'initiateWorkflowDto' is not null or undefined
            assertParamExists('initiateWorkflow', 'initiateWorkflowDto', initiateWorkflowDto)
            const localVarPath = `/issues/{code}/initiate-workflow`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateWorkflowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issues: async (sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/issues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignActionRequest: async (code: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('reassignActionRequest', 'code', code)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reassignActionRequest', 'id', id)
            const localVarPath = `/issues/{code}/actions/{id}/reassign-request`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignIssueRequest: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('reassignIssueRequest', 'code', code)
            const localVarPath = `/issues/{code}/reassign-request`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {SaveIssueRequestDto} saveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIssue: async (code: string, saveIssueRequestDto: SaveIssueRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('saveIssue', 'code', code)
            // verify required parameter 'saveIssueRequestDto' is not null or undefined
            assertParamExists('saveIssue', 'saveIssueRequestDto', saveIssueRequestDto)
            const localVarPath = `/issues/{code}/save`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAction: async (code: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('startAction', 'code', code)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startAction', 'id', id)
            const localVarPath = `/issues/{code}/actions/{id}/start`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {UpdateSLAStatusRequestDto} updateSLAStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSLAStatus: async (code: string, updateSLAStatusRequestDto: UpdateSLAStatusRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateSLAStatus', 'code', code)
            // verify required parameter 'updateSLAStatusRequestDto' is not null or undefined
            assertParamExists('updateSLAStatus', 'updateSLAStatusRequestDto', updateSLAStatusRequestDto)
            const localVarPath = `/issues/{code}/update-sla-status`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSLAStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssuesApi - functional programming interface
 * @export
 */
export const IssuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {ApproveActionDto} approveActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAction(code: string, id: string, approveActionDto: ApproveActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAction(code, id, approveActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {ApproveIssueRequestDto} approveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveIssue(code: string, approveIssueRequestDto: ApproveIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveIssue(code, approveIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AssignIssueRequestDto} assignIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignIssue(code: string, assignIssueRequestDto: AssignIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignIssue(code, assignIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {CreateIssueRequestDto} createIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssue(createIssueRequestDto: CreateIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssue(createIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AddCommentRequestDto} addCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssueComment(code: string, addCommentRequestDto: AddCommentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssueComment(code, addCommentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {DeclineActionRequestDto} declineActionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineAction(code: string, id: string, declineActionRequestDto: DeclineActionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineAction(code, id, declineActionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DeclineIssueRequestDto} declineIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineIssue(code: string, declineIssueRequestDto: DeclineIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineIssue(code, declineIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DiscardIssueRequestDto} discardIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discardIssue(code: string, discardIssueRequestDto: DiscardIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discardIssue(code, discardIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {FinishActionDto} finishActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishAction(code: string, id: string, finishActionDto: FinishActionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishAction(code, id, finishActionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssue(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssue(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuickFilterStatistics(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuickFilterStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuickFilterStatistics(sort, filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssuesStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRoles(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRoles(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {InitiateWorkflowDto} initiateWorkflowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateWorkflow(code: string, initiateWorkflowDto: InitiateWorkflowDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateWorkflow(code, initiateWorkflowDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issues(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Issues200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issues(sort, filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reassignActionRequest(code: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reassignActionRequest(code, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reassignIssueRequest(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reassignIssueRequest(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {SaveIssueRequestDto} saveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveIssue(code: string, saveIssueRequestDto: SaveIssueRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveIssue(code, saveIssueRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAction(code: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAction(code, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {UpdateSLAStatusRequestDto} updateSLAStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSLAStatus(code: string, updateSLAStatusRequestDto: UpdateSLAStatusRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSLAStatus(code, updateSLAStatusRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssuesApi - factory interface
 * @export
 */
export const IssuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssuesApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {ApproveActionDto} approveActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAction(code: string, id: string, approveActionDto: ApproveActionDto, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.approveAction(code, id, approveActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {ApproveIssueRequestDto} approveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveIssue(code: string, approveIssueRequestDto: ApproveIssueRequestDto, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.approveIssue(code, approveIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AssignIssueRequestDto} assignIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignIssue(code: string, assignIssueRequestDto: AssignIssueRequestDto, options?: any): AxiosPromise<IssueResponseDto> {
            return localVarFp.assignIssue(code, assignIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {CreateIssueRequestDto} createIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue(createIssueRequestDto: CreateIssueRequestDto, options?: any): AxiosPromise<CreateIssueResponseDto> {
            return localVarFp.createIssue(createIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {AddCommentRequestDto} addCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssueComment(code: string, addCommentRequestDto: AddCommentRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.createIssueComment(code, addCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {DeclineActionRequestDto} declineActionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineAction(code: string, id: string, declineActionRequestDto: DeclineActionRequestDto, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.declineAction(code, id, declineActionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DeclineIssueRequestDto} declineIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineIssue(code: string, declineIssueRequestDto: DeclineIssueRequestDto, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.declineIssue(code, declineIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {DiscardIssueRequestDto} discardIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardIssue(code: string, discardIssueRequestDto: DiscardIssueRequestDto, options?: any): AxiosPromise<IssueResponseDto> {
            return localVarFp.discardIssue(code, discardIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {FinishActionDto} finishActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishAction(code: string, id: string, finishActionDto: FinishActionDto, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.finishAction(code, id, finishActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue(code: string, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.getIssue(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuickFilterStatistics(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<GetQuickFilterStatisticsResponseDto> {
            return localVarFp.getQuickFilterStatistics(sort, filter, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(options?: any): AxiosPromise<GetIssuesStatisticsResponseDto> {
            return localVarFp.getStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRoles(code: string, options?: any): AxiosPromise<GetUserRolesResponseDto> {
            return localVarFp.getUserRoles(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {InitiateWorkflowDto} initiateWorkflowDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateWorkflow(code: string, initiateWorkflowDto: InitiateWorkflowDto, options?: any): AxiosPromise<IssueResponseDto> {
            return localVarFp.initiateWorkflow(code, initiateWorkflowDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {IssueSortingDtoOptions} [sort] 
         * @param {IssueFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issues(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<Issues200Response> {
            return localVarFp.issues(sort, filter, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignActionRequest(code: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.reassignActionRequest(code, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignIssueRequest(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.reassignIssueRequest(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {SaveIssueRequestDto} saveIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIssue(code: string, saveIssueRequestDto: SaveIssueRequestDto, options?: any): AxiosPromise<IssueResponseDto> {
            return localVarFp.saveIssue(code, saveIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAction(code: string, id: string, options?: any): AxiosPromise<GetIssueResponseDto> {
            return localVarFp.startAction(code, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} code 
         * @param {UpdateSLAStatusRequestDto} updateSLAStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSLAStatus(code: string, updateSLAStatusRequestDto: UpdateSLAStatusRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateSLAStatus(code, updateSLAStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssuesApi - object-oriented interface
 * @export
 * @class IssuesApi
 * @extends {BaseAPI}
 */
export class IssuesApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {string} id 
     * @param {ApproveActionDto} approveActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public approveAction(code: string, id: string, approveActionDto: ApproveActionDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).approveAction(code, id, approveActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {ApproveIssueRequestDto} approveIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public approveIssue(code: string, approveIssueRequestDto: ApproveIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).approveIssue(code, approveIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {AssignIssueRequestDto} assignIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public assignIssue(code: string, assignIssueRequestDto: AssignIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).assignIssue(code, assignIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {CreateIssueRequestDto} createIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public createIssue(createIssueRequestDto: CreateIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).createIssue(createIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {AddCommentRequestDto} addCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public createIssueComment(code: string, addCommentRequestDto: AddCommentRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).createIssueComment(code, addCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {string} id 
     * @param {DeclineActionRequestDto} declineActionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public declineAction(code: string, id: string, declineActionRequestDto: DeclineActionRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).declineAction(code, id, declineActionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {DeclineIssueRequestDto} declineIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public declineIssue(code: string, declineIssueRequestDto: DeclineIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).declineIssue(code, declineIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {DiscardIssueRequestDto} discardIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public discardIssue(code: string, discardIssueRequestDto: DiscardIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).discardIssue(code, discardIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {string} id 
     * @param {FinishActionDto} finishActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public finishAction(code: string, id: string, finishActionDto: FinishActionDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).finishAction(code, id, finishActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public getIssue(code: string, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).getIssue(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {IssueSortingDtoOptions} [sort] 
     * @param {IssueFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public getQuickFilterStatistics(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).getQuickFilterStatistics(sort, filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public getStatistics(options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).getStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public getUserRoles(code: string, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).getUserRoles(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {InitiateWorkflowDto} initiateWorkflowDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public initiateWorkflow(code: string, initiateWorkflowDto: InitiateWorkflowDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).initiateWorkflow(code, initiateWorkflowDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {IssueSortingDtoOptions} [sort] 
     * @param {IssueFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public issues(sort?: IssueSortingDtoOptions, filter?: IssueFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).issues(sort, filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public reassignActionRequest(code: string, id: string, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).reassignActionRequest(code, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public reassignIssueRequest(code: string, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).reassignIssueRequest(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {SaveIssueRequestDto} saveIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public saveIssue(code: string, saveIssueRequestDto: SaveIssueRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).saveIssue(code, saveIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public startAction(code: string, id: string, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).startAction(code, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} code 
     * @param {UpdateSLAStatusRequestDto} updateSLAStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuesApi
     */
    public updateSLAStatus(code: string, updateSLAStatusRequestDto: UpdateSLAStatusRequestDto, options?: AxiosRequestConfig) {
        return IssuesApiFp(this.configuration).updateSLAStatus(code, updateSLAStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringApi - axios parameter creator
 * @export
 */
export const MonitoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {ClientMonitoringEventDto} clientMonitoringEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEvent: async (clientMonitoringEventDto: ClientMonitoringEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientMonitoringEventDto' is not null or undefined
            assertParamExists('sendEvent', 'clientMonitoringEventDto', clientMonitoringEventDto)
            const localVarPath = `/monitoring/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientMonitoringEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringApi - functional programming interface
 * @export
 */
export const MonitoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {ClientMonitoringEventDto} clientMonitoringEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEvent(clientMonitoringEventDto: ClientMonitoringEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEvent(clientMonitoringEventDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringApi - factory interface
 * @export
 */
export const MonitoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {ClientMonitoringEventDto} clientMonitoringEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEvent(clientMonitoringEventDto: ClientMonitoringEventDto, options?: any): AxiosPromise<void> {
            return localVarFp.sendEvent(clientMonitoringEventDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringApi - object-oriented interface
 * @export
 * @class MonitoringApi
 * @extends {BaseAPI}
 */
export class MonitoringApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {ClientMonitoringEventDto} clientMonitoringEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringApi
     */
    public sendEvent(clientMonitoringEventDto: ClientMonitoringEventDto, options?: AxiosRequestConfig) {
        return MonitoringApiFp(this.configuration).sendEvent(clientMonitoringEventDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SlasApi - axios parameter creator
 * @export
 */
export const SlasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {CreateSLARequestDto} createSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSLA: async (createSLARequestDto: CreateSLARequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSLARequestDto' is not null or undefined
            assertParamExists('createSLA', 'createSLARequestDto', createSLARequestDto)
            const localVarPath = `/slas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSLARequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {DeleteSLAsRequestDto} deleteSLAsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSLAs: async (deleteSLAsRequestDto: DeleteSLAsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSLAsRequestDto' is not null or undefined
            assertParamExists('deleteSLAs', 'deleteSLAsRequestDto', deleteSLAsRequestDto)
            const localVarPath = `/slas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSLAsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {SLASortingDtoOptions} [sort] 
         * @param {SLAFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slas: async (sort?: SLASortingDtoOptions, filter?: SLAFilteringDtoOptions, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateSLARequestDto} updateSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSLA: async (id: string, updateSLARequestDto: UpdateSLARequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSLA', 'id', id)
            // verify required parameter 'updateSLARequestDto' is not null or undefined
            assertParamExists('updateSLA', 'updateSLARequestDto', updateSLARequestDto)
            const localVarPath = `/slas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSLARequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SlasApi - functional programming interface
 * @export
 */
export const SlasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SlasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateSLARequestDto} createSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSLA(createSLARequestDto: CreateSLARequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSLAResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSLA(createSLARequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {DeleteSLAsRequestDto} deleteSLAsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSLAs(deleteSLAsRequestDto: DeleteSLAsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSLAs(deleteSLAsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {SLASortingDtoOptions} [sort] 
         * @param {SLAFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slas(sort?: SLASortingDtoOptions, filter?: SLAFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Slas200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slas(sort, filter, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateSLARequestDto} updateSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSLA(id: string, updateSLARequestDto: UpdateSLARequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSLAResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSLA(id, updateSLARequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SlasApi - factory interface
 * @export
 */
export const SlasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SlasApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {CreateSLARequestDto} createSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSLA(createSLARequestDto: CreateSLARequestDto, options?: any): AxiosPromise<CreateSLAResponseDto> {
            return localVarFp.createSLA(createSLARequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {DeleteSLAsRequestDto} deleteSLAsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSLAs(deleteSLAsRequestDto: DeleteSLAsRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSLAs(deleteSLAsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {SLASortingDtoOptions} [sort] 
         * @param {SLAFilteringDtoOptions} [filter] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slas(sort?: SLASortingDtoOptions, filter?: SLAFilteringDtoOptions, page?: number, limit?: number, options?: any): AxiosPromise<Slas200Response> {
            return localVarFp.slas(sort, filter, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {UpdateSLARequestDto} updateSLARequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSLA(id: string, updateSLARequestDto: UpdateSLARequestDto, options?: any): AxiosPromise<CreateSLAResponseDto> {
            return localVarFp.updateSLA(id, updateSLARequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SlasApi - object-oriented interface
 * @export
 * @class SlasApi
 * @extends {BaseAPI}
 */
export class SlasApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {CreateSLARequestDto} createSLARequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlasApi
     */
    public createSLA(createSLARequestDto: CreateSLARequestDto, options?: AxiosRequestConfig) {
        return SlasApiFp(this.configuration).createSLA(createSLARequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {DeleteSLAsRequestDto} deleteSLAsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlasApi
     */
    public deleteSLAs(deleteSLAsRequestDto: DeleteSLAsRequestDto, options?: AxiosRequestConfig) {
        return SlasApiFp(this.configuration).deleteSLAs(deleteSLAsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {SLASortingDtoOptions} [sort] 
     * @param {SLAFilteringDtoOptions} [filter] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlasApi
     */
    public slas(sort?: SLASortingDtoOptions, filter?: SLAFilteringDtoOptions, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return SlasApiFp(this.configuration).slas(sort, filter, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {UpdateSLARequestDto} updateSLARequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlasApi
     */
    public updateSLA(id: string, updateSLARequestDto: UpdateSLARequestDto, options?: AxiosRequestConfig) {
        return SlasApiFp(this.configuration).updateSLA(id, updateSLARequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {UserSortingDtoOptions} [sort] 
         * @param {UserFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        users: async (page: number, limit: number, sort?: UserSortingDtoOptions, filter?: UserFilteringDtoOptions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('users', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('users', 'limit', limit)
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentRoles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentUserRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentRoles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {UserSortingDtoOptions} [sort] 
         * @param {UserFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async users(page: number, limit: number, sort?: UserSortingDtoOptions, filter?: UserFilteringDtoOptions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Users200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.users(page, limit, sort, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoles(options?: any): AxiosPromise<GetCurrentUserRolesResponseDto> {
            return localVarFp.getCurrentRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options?: any): AxiosPromise<GetUserResponseDto> {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {number} page 
         * @param {number} limit 
         * @param {UserSortingDtoOptions} [sort] 
         * @param {UserFilteringDtoOptions} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        users(page: number, limit: number, sort?: UserSortingDtoOptions, filter?: UserFilteringDtoOptions, options?: any): AxiosPromise<Users200Response> {
            return localVarFp.users(page, limit, sort, filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCurrentRoles(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCurrentRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMe(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {number} page 
     * @param {number} limit 
     * @param {UserSortingDtoOptions} [sort] 
     * @param {UserFilteringDtoOptions} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public users(page: number, limit: number, sort?: UserSortingDtoOptions, filter?: UserFilteringDtoOptions, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).users(page, limit, sort, filter, options).then((request) => request(this.axios, this.basePath));
    }
}


